import { e as po, F as wo, b as $e, d as go, m as at, k as bo, l as vo, r as yo, q as Co, t as ko, u as _o, v as Io, p as jt, f as Do, j as So } from "./index-E8vB_04G.js";
import { G as mi } from "./index-E8vB_04G.js";
import { DataLabDataset as xt } from "ddc";
import { Compiler as wi, DataLabDataset as gi, data_science_commit as bi, data_science_data_room as vi, lookalike_media_request as yi, media_insights_request as Ci } from "ddc";
import { a as No } from "./session-DyDHabUm.js";
import { S as _i } from "./session-DyDHabUm.js";
import { g as Rt, D as lt, r as gt, j as Nt, k as Tt, h as ae } from "./utils-dinPOBnH.js";
import { A as Di, m as Si, C as Ni, n as Ei, S as Ri, U as xi, l as ji, u as Ai } from "./utils-dinPOBnH.js";
import { C as Eo, S as Ro, e as oo, g as xo, a as At, A as jo, D as Ao, b as To, G as Jo, M as Oo, c as zo, P as Po, d as $o, f as $t, h as no, i as Fo, j as Uo, k as Mo, l as Lo, m as Ko, n as Bo } from "./attestation-CPbOedrn.js";
import { o as Ji, p as Oi } from "./attestation-CPbOedrn.js";
import { Auth as Pi } from "./authentication.js";
import { D as yt, a as qo } from "./builders-D99X3ba6.js";
import { G as Fi, b as Ui } from "./builders-D99X3ba6.js";
import { C as Li, c as Ki } from "./client-CUQHQEcE.js";
import { Noop as qi, StaticContent as Hi } from "./compute.js";
import { d as _t } from "./index-Buti0PLx.js";
import { c as Mt } from "./_commonjsHelpers-CT_km90n.js";
import { n as Ho, c as Lt } from "./nacl-fast-DmSj04OB.js";
import { l as X } from "./index-b-LDu0Rp.js";
import "sgx-ias-verifier";
import "./config.js";
import "./lodash-CQY7Uy6L.js";
import "./index-jyncyKHm.js";
import "./index-Ch-rSMgZ.js";
import { Endorser as Wi } from "./endorsement.js";
import { Permissions as G } from "./permission.js";
import { n as Gi } from "./node-CFp4nLsf.js";
import { t as Yi } from "./types-CMDdNX_5.js";
class Ct {
  material;
  /**
   * Returns a new `Key` instance, can optionally specify the raw key material
   */
  constructor(t) {
    let e;
    if (t === void 0)
      e = Ho.randomBytes(32);
    else {
      if (t.length !== 32)
        throw new Error("Invalid key length, must be 32 bytes");
      e = t;
    }
    this.material = e;
  }
  toHex() {
    return X.util.binary.hex.encode(this.material);
  }
}
const Zo = { ...po, ...wo }, ni = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ContainerWorkerDecoder: Eo,
  StaticContainerCompute: Ro,
  proto: Zo
}, Symbol.toStringTag, { value: "Module" }));
var io = { exports: {} };
(function(s, t) {
  (function(e) {
    s.exports = e();
  })(function() {
    return function e(o, n, i) {
      function a(m, u) {
        if (!n[m]) {
          if (!o[m]) {
            var w = typeof Lt == "function" && Lt;
            if (!u && w)
              return w(m, !0);
            if (r)
              return r(m, !0);
            var g = new Error("Cannot find module '" + m + "'");
            throw g.code = "MODULE_NOT_FOUND", g;
          }
          var f = n[m] = { exports: {} };
          o[m][0].call(f.exports, function(v) {
            var h = o[m][1][v];
            return a(h || v);
          }, f, f.exports, e, o, n, i);
        }
        return n[m].exports;
      }
      for (var r = typeof Lt == "function" && Lt, c = 0; c < i.length; c++)
        a(i[c]);
      return a;
    }({ 1: [function(e, o, n) {
      var i = e("./utils"), a = e("./support"), r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      n.encode = function(c) {
        for (var m, u, w, g, f, v, h, b = [], p = 0, y = c.length, _ = y, S = i.getTypeOf(c) !== "string"; p < c.length; )
          _ = y - p, w = S ? (m = c[p++], u = p < y ? c[p++] : 0, p < y ? c[p++] : 0) : (m = c.charCodeAt(p++), u = p < y ? c.charCodeAt(p++) : 0, p < y ? c.charCodeAt(p++) : 0), g = m >> 2, f = (3 & m) << 4 | u >> 4, v = 1 < _ ? (15 & u) << 2 | w >> 6 : 64, h = 2 < _ ? 63 & w : 64, b.push(r.charAt(g) + r.charAt(f) + r.charAt(v) + r.charAt(h));
        return b.join("");
      }, n.decode = function(c) {
        var m, u, w, g, f, v, h = 0, b = 0, p = "data:";
        if (c.substr(0, p.length) === p)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var y, _ = 3 * (c = c.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (c.charAt(c.length - 1) === r.charAt(64) && _--, c.charAt(c.length - 2) === r.charAt(64) && _--, _ % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (y = a.uint8array ? new Uint8Array(0 | _) : new Array(0 | _); h < c.length; )
          m = r.indexOf(c.charAt(h++)) << 2 | (g = r.indexOf(c.charAt(h++))) >> 4, u = (15 & g) << 4 | (f = r.indexOf(c.charAt(h++))) >> 2, w = (3 & f) << 6 | (v = r.indexOf(c.charAt(h++))), y[b++] = m, f !== 64 && (y[b++] = u), v !== 64 && (y[b++] = w);
        return y;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(e, o, n) {
      var i = e("./external"), a = e("./stream/DataWorker"), r = e("./stream/Crc32Probe"), c = e("./stream/DataLengthProbe");
      function m(u, w, g, f, v) {
        this.compressedSize = u, this.uncompressedSize = w, this.crc32 = g, this.compression = f, this.compressedContent = v;
      }
      m.prototype = { getContentWorker: function() {
        var u = new a(i.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new c("data_length")), w = this;
        return u.on("end", function() {
          if (this.streamInfo.data_length !== w.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), u;
      }, getCompressedWorker: function() {
        return new a(i.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, m.createWorkerFrom = function(u, w, g) {
        return u.pipe(new r()).pipe(new c("uncompressedSize")).pipe(w.compressWorker(g)).pipe(new c("compressedSize")).withStreamInfo("compression", w);
      }, o.exports = m;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(e, o, n) {
      var i = e("./stream/GenericWorker");
      n.STORE = { magic: "\0\0", compressWorker: function() {
        return new i("STORE compression");
      }, uncompressWorker: function() {
        return new i("STORE decompression");
      } }, n.DEFLATE = e("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(e, o, n) {
      var i = e("./utils"), a = function() {
        for (var r, c = [], m = 0; m < 256; m++) {
          r = m;
          for (var u = 0; u < 8; u++)
            r = 1 & r ? 3988292384 ^ r >>> 1 : r >>> 1;
          c[m] = r;
        }
        return c;
      }();
      o.exports = function(r, c) {
        return r !== void 0 && r.length ? i.getTypeOf(r) !== "string" ? function(m, u, w, g) {
          var f = a, v = g + w;
          m ^= -1;
          for (var h = g; h < v; h++)
            m = m >>> 8 ^ f[255 & (m ^ u[h])];
          return -1 ^ m;
        }(0 | c, r, r.length, 0) : function(m, u, w, g) {
          var f = a, v = g + w;
          m ^= -1;
          for (var h = g; h < v; h++)
            m = m >>> 8 ^ f[255 & (m ^ u.charCodeAt(h))];
          return -1 ^ m;
        }(0 | c, r, r.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(e, o, n) {
      n.base64 = !1, n.binary = !1, n.dir = !1, n.createFolders = !0, n.date = null, n.compression = null, n.compressionOptions = null, n.comment = null, n.unixPermissions = null, n.dosPermissions = null;
    }, {}], 6: [function(e, o, n) {
      var i = null;
      i = typeof Promise < "u" ? Promise : e("lie"), o.exports = { Promise: i };
    }, { lie: 37 }], 7: [function(e, o, n) {
      var i = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", a = e("pako"), r = e("./utils"), c = e("./stream/GenericWorker"), m = i ? "uint8array" : "array";
      function u(w, g) {
        c.call(this, "FlateWorker/" + w), this._pako = null, this._pakoAction = w, this._pakoOptions = g, this.meta = {};
      }
      n.magic = "\b\0", r.inherits(u, c), u.prototype.processChunk = function(w) {
        this.meta = w.meta, this._pako === null && this._createPako(), this._pako.push(r.transformTo(m, w.data), !1);
      }, u.prototype.flush = function() {
        c.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, u.prototype.cleanUp = function() {
        c.prototype.cleanUp.call(this), this._pako = null;
      }, u.prototype._createPako = function() {
        this._pako = new a[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var w = this;
        this._pako.onData = function(g) {
          w.push({ data: g, meta: w.meta });
        };
      }, n.compressWorker = function(w) {
        return new u("Deflate", w);
      }, n.uncompressWorker = function() {
        return new u("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(e, o, n) {
      function i(f, v) {
        var h, b = "";
        for (h = 0; h < v; h++)
          b += String.fromCharCode(255 & f), f >>>= 8;
        return b;
      }
      function a(f, v, h, b, p, y) {
        var _, S, D = f.file, T = f.compression, x = y !== m.utf8encode, F = r.transformTo("string", y(D.name)), A = r.transformTo("string", m.utf8encode(D.name)), M = D.comment, V = r.transformTo("string", y(M)), I = r.transformTo("string", m.utf8encode(M)), O = A.length !== D.name.length, l = I.length !== M.length, P = "", et = "", L = "", ot = D.dir, K = D.date, tt = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        v && !h || (tt.crc32 = f.crc32, tt.compressedSize = f.compressedSize, tt.uncompressedSize = f.uncompressedSize);
        var j = 0;
        v && (j |= 8), x || !O && !l || (j |= 2048);
        var R = 0, Q = 0;
        ot && (R |= 16), p === "UNIX" ? (Q = 798, R |= function(H, ct) {
          var wt = H;
          return H || (wt = ct ? 16893 : 33204), (65535 & wt) << 16;
        }(D.unixPermissions, ot)) : (Q = 20, R |= function(H) {
          return 63 & (H || 0);
        }(D.dosPermissions)), _ = K.getUTCHours(), _ <<= 6, _ |= K.getUTCMinutes(), _ <<= 5, _ |= K.getUTCSeconds() / 2, S = K.getUTCFullYear() - 1980, S <<= 4, S |= K.getUTCMonth() + 1, S <<= 5, S |= K.getUTCDate(), O && (et = i(1, 1) + i(u(F), 4) + A, P += "up" + i(et.length, 2) + et), l && (L = i(1, 1) + i(u(V), 4) + I, P += "uc" + i(L.length, 2) + L);
        var Z = "";
        return Z += `
\0`, Z += i(j, 2), Z += T.magic, Z += i(_, 2), Z += i(S, 2), Z += i(tt.crc32, 4), Z += i(tt.compressedSize, 4), Z += i(tt.uncompressedSize, 4), Z += i(F.length, 2), Z += i(P.length, 2), { fileRecord: w.LOCAL_FILE_HEADER + Z + F + P, dirRecord: w.CENTRAL_FILE_HEADER + i(Q, 2) + Z + i(V.length, 2) + "\0\0\0\0" + i(R, 4) + i(b, 4) + F + P + V };
      }
      var r = e("../utils"), c = e("../stream/GenericWorker"), m = e("../utf8"), u = e("../crc32"), w = e("../signature");
      function g(f, v, h, b) {
        c.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = v, this.zipPlatform = h, this.encodeFileName = b, this.streamFiles = f, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      r.inherits(g, c), g.prototype.push = function(f) {
        var v = f.meta.percent || 0, h = this.entriesCount, b = this._sources.length;
        this.accumulate ? this.contentBuffer.push(f) : (this.bytesWritten += f.data.length, c.prototype.push.call(this, { data: f.data, meta: { currentFile: this.currentFile, percent: h ? (v + 100 * (h - b - 1)) / h : 100 } }));
      }, g.prototype.openedSource = function(f) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = f.file.name;
        var v = this.streamFiles && !f.file.dir;
        if (v) {
          var h = a(f, v, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: h.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, g.prototype.closedSource = function(f) {
        this.accumulate = !1;
        var v = this.streamFiles && !f.file.dir, h = a(f, v, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(h.dirRecord), v)
          this.push({ data: function(b) {
            return w.DATA_DESCRIPTOR + i(b.crc32, 4) + i(b.compressedSize, 4) + i(b.uncompressedSize, 4);
          }(f), meta: { percent: 100 } });
        else
          for (this.push({ data: h.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, g.prototype.flush = function() {
        for (var f = this.bytesWritten, v = 0; v < this.dirRecords.length; v++)
          this.push({ data: this.dirRecords[v], meta: { percent: 100 } });
        var h = this.bytesWritten - f, b = function(p, y, _, S, D) {
          var T = r.transformTo("string", D(S));
          return w.CENTRAL_DIRECTORY_END + "\0\0\0\0" + i(p, 2) + i(p, 2) + i(y, 4) + i(_, 4) + i(T.length, 2) + T;
        }(this.dirRecords.length, h, f, this.zipComment, this.encodeFileName);
        this.push({ data: b, meta: { percent: 100 } });
      }, g.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, g.prototype.registerPrevious = function(f) {
        this._sources.push(f);
        var v = this;
        return f.on("data", function(h) {
          v.processChunk(h);
        }), f.on("end", function() {
          v.closedSource(v.previous.streamInfo), v._sources.length ? v.prepareNextSource() : v.end();
        }), f.on("error", function(h) {
          v.error(h);
        }), this;
      }, g.prototype.resume = function() {
        return !!c.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, g.prototype.error = function(f) {
        var v = this._sources;
        if (!c.prototype.error.call(this, f))
          return !1;
        for (var h = 0; h < v.length; h++)
          try {
            v[h].error(f);
          } catch {
          }
        return !0;
      }, g.prototype.lock = function() {
        c.prototype.lock.call(this);
        for (var f = this._sources, v = 0; v < f.length; v++)
          f[v].lock();
      }, o.exports = g;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(e, o, n) {
      var i = e("../compressions"), a = e("./ZipFileWorker");
      n.generateWorker = function(r, c, m) {
        var u = new a(c.streamFiles, m, c.platform, c.encodeFileName), w = 0;
        try {
          r.forEach(function(g, f) {
            w++;
            var v = function(y, _) {
              var S = y || _, D = i[S];
              if (!D)
                throw new Error(S + " is not a valid compression method !");
              return D;
            }(f.options.compression, c.compression), h = f.options.compressionOptions || c.compressionOptions || {}, b = f.dir, p = f.date;
            f._compressWorker(v, h).withStreamInfo("file", { name: g, dir: b, date: p, comment: f.comment || "", unixPermissions: f.unixPermissions, dosPermissions: f.dosPermissions }).pipe(u);
          }), u.entriesCount = w;
        } catch (g) {
          u.error(g);
        }
        return u;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(e, o, n) {
      function i() {
        if (!(this instanceof i))
          return new i();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var a = new i();
          for (var r in this)
            typeof this[r] != "function" && (a[r] = this[r]);
          return a;
        };
      }
      (i.prototype = e("./object")).loadAsync = e("./load"), i.support = e("./support"), i.defaults = e("./defaults"), i.version = "3.10.1", i.loadAsync = function(a, r) {
        return new i().loadAsync(a, r);
      }, i.external = e("./external"), o.exports = i;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(e, o, n) {
      var i = e("./utils"), a = e("./external"), r = e("./utf8"), c = e("./zipEntries"), m = e("./stream/Crc32Probe"), u = e("./nodejsUtils");
      function w(g) {
        return new a.Promise(function(f, v) {
          var h = g.decompressed.getContentWorker().pipe(new m());
          h.on("error", function(b) {
            v(b);
          }).on("end", function() {
            h.streamInfo.crc32 !== g.decompressed.crc32 ? v(new Error("Corrupted zip : CRC32 mismatch")) : f();
          }).resume();
        });
      }
      o.exports = function(g, f) {
        var v = this;
        return f = i.extend(f || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: r.utf8decode }), u.isNode && u.isStream(g) ? a.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : i.prepareContent("the loaded zip file", g, !0, f.optimizedBinaryString, f.base64).then(function(h) {
          var b = new c(f);
          return b.load(h), b;
        }).then(function(h) {
          var b = [a.Promise.resolve(h)], p = h.files;
          if (f.checkCRC32)
            for (var y = 0; y < p.length; y++)
              b.push(w(p[y]));
          return a.Promise.all(b);
        }).then(function(h) {
          for (var b = h.shift(), p = b.files, y = 0; y < p.length; y++) {
            var _ = p[y], S = _.fileNameStr, D = i.resolve(_.fileNameStr);
            v.file(D, _.decompressed, { binary: !0, optimizedBinaryString: !0, date: _.date, dir: _.dir, comment: _.fileCommentStr.length ? _.fileCommentStr : null, unixPermissions: _.unixPermissions, dosPermissions: _.dosPermissions, createFolders: f.createFolders }), _.dir || (v.file(D).unsafeOriginalName = S);
          }
          return b.zipComment.length && (v.comment = b.zipComment), v;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(e, o, n) {
      var i = e("../utils"), a = e("../stream/GenericWorker");
      function r(c, m) {
        a.call(this, "Nodejs stream input adapter for " + c), this._upstreamEnded = !1, this._bindStream(m);
      }
      i.inherits(r, a), r.prototype._bindStream = function(c) {
        var m = this;
        (this._stream = c).pause(), c.on("data", function(u) {
          m.push({ data: u, meta: { percent: 0 } });
        }).on("error", function(u) {
          m.isPaused ? this.generatedError = u : m.error(u);
        }).on("end", function() {
          m.isPaused ? m._upstreamEnded = !0 : m.end();
        });
      }, r.prototype.pause = function() {
        return !!a.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, r.prototype.resume = function() {
        return !!a.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, o.exports = r;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(e, o, n) {
      var i = e("readable-stream").Readable;
      function a(r, c, m) {
        i.call(this, c), this._helper = r;
        var u = this;
        r.on("data", function(w, g) {
          u.push(w) || u._helper.pause(), m && m(g);
        }).on("error", function(w) {
          u.emit("error", w);
        }).on("end", function() {
          u.push(null);
        });
      }
      e("../utils").inherits(a, i), a.prototype._read = function() {
        this._helper.resume();
      }, o.exports = a;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(e, o, n) {
      o.exports = { isNode: typeof _t.Buffer < "u", newBufferFrom: function(i, a) {
        if (_t.Buffer.from && _t.Buffer.from !== Uint8Array.from)
          return _t.Buffer.from(i, a);
        if (typeof i == "number")
          throw new Error('The "data" argument must not be a number');
        return new _t.Buffer(i, a);
      }, allocBuffer: function(i) {
        if (_t.Buffer.alloc)
          return _t.Buffer.alloc(i);
        var a = new _t.Buffer(i);
        return a.fill(0), a;
      }, isBuffer: function(i) {
        return _t.Buffer.isBuffer(i);
      }, isStream: function(i) {
        return i && typeof i.on == "function" && typeof i.pause == "function" && typeof i.resume == "function";
      } };
    }, {}], 15: [function(e, o, n) {
      function i(D, T, x) {
        var F, A = r.getTypeOf(T), M = r.extend(x || {}, u);
        M.date = M.date || /* @__PURE__ */ new Date(), M.compression !== null && (M.compression = M.compression.toUpperCase()), typeof M.unixPermissions == "string" && (M.unixPermissions = parseInt(M.unixPermissions, 8)), M.unixPermissions && 16384 & M.unixPermissions && (M.dir = !0), M.dosPermissions && 16 & M.dosPermissions && (M.dir = !0), M.dir && (D = p(D)), M.createFolders && (F = b(D)) && y.call(this, F, !0);
        var V = A === "string" && M.binary === !1 && M.base64 === !1;
        x && x.binary !== void 0 || (M.binary = !V), (T instanceof w && T.uncompressedSize === 0 || M.dir || !T || T.length === 0) && (M.base64 = !1, M.binary = !0, T = "", M.compression = "STORE", A = "string");
        var I = null;
        I = T instanceof w || T instanceof c ? T : v.isNode && v.isStream(T) ? new h(D, T) : r.prepareContent(D, T, M.binary, M.optimizedBinaryString, M.base64);
        var O = new g(D, I, M);
        this.files[D] = O;
      }
      var a = e("./utf8"), r = e("./utils"), c = e("./stream/GenericWorker"), m = e("./stream/StreamHelper"), u = e("./defaults"), w = e("./compressedObject"), g = e("./zipObject"), f = e("./generate"), v = e("./nodejsUtils"), h = e("./nodejs/NodejsStreamInputAdapter"), b = function(D) {
        D.slice(-1) === "/" && (D = D.substring(0, D.length - 1));
        var T = D.lastIndexOf("/");
        return 0 < T ? D.substring(0, T) : "";
      }, p = function(D) {
        return D.slice(-1) !== "/" && (D += "/"), D;
      }, y = function(D, T) {
        return T = T !== void 0 ? T : u.createFolders, D = p(D), this.files[D] || i.call(this, D, null, { dir: !0, createFolders: T }), this.files[D];
      };
      function _(D) {
        return Object.prototype.toString.call(D) === "[object RegExp]";
      }
      var S = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(D) {
        var T, x, F;
        for (T in this.files)
          F = this.files[T], (x = T.slice(this.root.length, T.length)) && T.slice(0, this.root.length) === this.root && D(x, F);
      }, filter: function(D) {
        var T = [];
        return this.forEach(function(x, F) {
          D(x, F) && T.push(F);
        }), T;
      }, file: function(D, T, x) {
        if (arguments.length !== 1)
          return D = this.root + D, i.call(this, D, T, x), this;
        if (_(D)) {
          var F = D;
          return this.filter(function(M, V) {
            return !V.dir && F.test(M);
          });
        }
        var A = this.files[this.root + D];
        return A && !A.dir ? A : null;
      }, folder: function(D) {
        if (!D)
          return this;
        if (_(D))
          return this.filter(function(A, M) {
            return M.dir && D.test(A);
          });
        var T = this.root + D, x = y.call(this, T), F = this.clone();
        return F.root = x.name, F;
      }, remove: function(D) {
        D = this.root + D;
        var T = this.files[D];
        if (T || (D.slice(-1) !== "/" && (D += "/"), T = this.files[D]), T && !T.dir)
          delete this.files[D];
        else
          for (var x = this.filter(function(A, M) {
            return M.name.slice(0, D.length) === D;
          }), F = 0; F < x.length; F++)
            delete this.files[x[F].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(D) {
        var T, x = {};
        try {
          if ((x = r.extend(D || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: a.utf8encode })).type = x.type.toLowerCase(), x.compression = x.compression.toUpperCase(), x.type === "binarystring" && (x.type = "string"), !x.type)
            throw new Error("No output type specified.");
          r.checkSupport(x.type), x.platform !== "darwin" && x.platform !== "freebsd" && x.platform !== "linux" && x.platform !== "sunos" || (x.platform = "UNIX"), x.platform === "win32" && (x.platform = "DOS");
          var F = x.comment || this.comment || "";
          T = f.generateWorker(this, x, F);
        } catch (A) {
          (T = new c("error")).error(A);
        }
        return new m(T, x.type || "string", x.mimeType);
      }, generateAsync: function(D, T) {
        return this.generateInternalStream(D).accumulate(T);
      }, generateNodeStream: function(D, T) {
        return (D = D || {}).type || (D.type = "nodebuffer"), this.generateInternalStream(D).toNodejsStream(T);
      } };
      o.exports = S;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(e, o, n) {
      o.exports = e("stream");
    }, { stream: void 0 }], 17: [function(e, o, n) {
      var i = e("./DataReader");
      function a(r) {
        i.call(this, r);
        for (var c = 0; c < this.data.length; c++)
          r[c] = 255 & r[c];
      }
      e("../utils").inherits(a, i), a.prototype.byteAt = function(r) {
        return this.data[this.zero + r];
      }, a.prototype.lastIndexOfSignature = function(r) {
        for (var c = r.charCodeAt(0), m = r.charCodeAt(1), u = r.charCodeAt(2), w = r.charCodeAt(3), g = this.length - 4; 0 <= g; --g)
          if (this.data[g] === c && this.data[g + 1] === m && this.data[g + 2] === u && this.data[g + 3] === w)
            return g - this.zero;
        return -1;
      }, a.prototype.readAndCheckSignature = function(r) {
        var c = r.charCodeAt(0), m = r.charCodeAt(1), u = r.charCodeAt(2), w = r.charCodeAt(3), g = this.readData(4);
        return c === g[0] && m === g[1] && u === g[2] && w === g[3];
      }, a.prototype.readData = function(r) {
        if (this.checkOffset(r), r === 0)
          return [];
        var c = this.data.slice(this.zero + this.index, this.zero + this.index + r);
        return this.index += r, c;
      }, o.exports = a;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(e, o, n) {
      var i = e("../utils");
      function a(r) {
        this.data = r, this.length = r.length, this.index = 0, this.zero = 0;
      }
      a.prototype = { checkOffset: function(r) {
        this.checkIndex(this.index + r);
      }, checkIndex: function(r) {
        if (this.length < this.zero + r || r < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + r + "). Corrupted zip ?");
      }, setIndex: function(r) {
        this.checkIndex(r), this.index = r;
      }, skip: function(r) {
        this.setIndex(this.index + r);
      }, byteAt: function() {
      }, readInt: function(r) {
        var c, m = 0;
        for (this.checkOffset(r), c = this.index + r - 1; c >= this.index; c--)
          m = (m << 8) + this.byteAt(c);
        return this.index += r, m;
      }, readString: function(r) {
        return i.transformTo("string", this.readData(r));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var r = this.readInt(4);
        return new Date(Date.UTC(1980 + (r >> 25 & 127), (r >> 21 & 15) - 1, r >> 16 & 31, r >> 11 & 31, r >> 5 & 63, (31 & r) << 1));
      } }, o.exports = a;
    }, { "../utils": 32 }], 19: [function(e, o, n) {
      var i = e("./Uint8ArrayReader");
      function a(r) {
        i.call(this, r);
      }
      e("../utils").inherits(a, i), a.prototype.readData = function(r) {
        this.checkOffset(r);
        var c = this.data.slice(this.zero + this.index, this.zero + this.index + r);
        return this.index += r, c;
      }, o.exports = a;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(e, o, n) {
      var i = e("./DataReader");
      function a(r) {
        i.call(this, r);
      }
      e("../utils").inherits(a, i), a.prototype.byteAt = function(r) {
        return this.data.charCodeAt(this.zero + r);
      }, a.prototype.lastIndexOfSignature = function(r) {
        return this.data.lastIndexOf(r) - this.zero;
      }, a.prototype.readAndCheckSignature = function(r) {
        return r === this.readData(4);
      }, a.prototype.readData = function(r) {
        this.checkOffset(r);
        var c = this.data.slice(this.zero + this.index, this.zero + this.index + r);
        return this.index += r, c;
      }, o.exports = a;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(e, o, n) {
      var i = e("./ArrayReader");
      function a(r) {
        i.call(this, r);
      }
      e("../utils").inherits(a, i), a.prototype.readData = function(r) {
        if (this.checkOffset(r), r === 0)
          return new Uint8Array(0);
        var c = this.data.subarray(this.zero + this.index, this.zero + this.index + r);
        return this.index += r, c;
      }, o.exports = a;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(e, o, n) {
      var i = e("../utils"), a = e("../support"), r = e("./ArrayReader"), c = e("./StringReader"), m = e("./NodeBufferReader"), u = e("./Uint8ArrayReader");
      o.exports = function(w) {
        var g = i.getTypeOf(w);
        return i.checkSupport(g), g !== "string" || a.uint8array ? g === "nodebuffer" ? new m(w) : a.uint8array ? new u(i.transformTo("uint8array", w)) : new r(i.transformTo("array", w)) : new c(w);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(e, o, n) {
      n.LOCAL_FILE_HEADER = "PK", n.CENTRAL_FILE_HEADER = "PK", n.CENTRAL_DIRECTORY_END = "PK", n.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", n.ZIP64_CENTRAL_DIRECTORY_END = "PK", n.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(e, o, n) {
      var i = e("./GenericWorker"), a = e("../utils");
      function r(c) {
        i.call(this, "ConvertWorker to " + c), this.destType = c;
      }
      a.inherits(r, i), r.prototype.processChunk = function(c) {
        this.push({ data: a.transformTo(this.destType, c.data), meta: c.meta });
      }, o.exports = r;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(e, o, n) {
      var i = e("./GenericWorker"), a = e("../crc32");
      function r() {
        i.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      e("../utils").inherits(r, i), r.prototype.processChunk = function(c) {
        this.streamInfo.crc32 = a(c.data, this.streamInfo.crc32 || 0), this.push(c);
      }, o.exports = r;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(e, o, n) {
      var i = e("../utils"), a = e("./GenericWorker");
      function r(c) {
        a.call(this, "DataLengthProbe for " + c), this.propName = c, this.withStreamInfo(c, 0);
      }
      i.inherits(r, a), r.prototype.processChunk = function(c) {
        if (c) {
          var m = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = m + c.data.length;
        }
        a.prototype.processChunk.call(this, c);
      }, o.exports = r;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(e, o, n) {
      var i = e("../utils"), a = e("./GenericWorker");
      function r(c) {
        a.call(this, "DataWorker");
        var m = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, c.then(function(u) {
          m.dataIsReady = !0, m.data = u, m.max = u && u.length || 0, m.type = i.getTypeOf(u), m.isPaused || m._tickAndRepeat();
        }, function(u) {
          m.error(u);
        });
      }
      i.inherits(r, a), r.prototype.cleanUp = function() {
        a.prototype.cleanUp.call(this), this.data = null;
      }, r.prototype.resume = function() {
        return !!a.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, i.delay(this._tickAndRepeat, [], this)), !0);
      }, r.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (i.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, r.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var c = null, m = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            c = this.data.substring(this.index, m);
            break;
          case "uint8array":
            c = this.data.subarray(this.index, m);
            break;
          case "array":
          case "nodebuffer":
            c = this.data.slice(this.index, m);
        }
        return this.index = m, this.push({ data: c, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, o.exports = r;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(e, o, n) {
      function i(a) {
        this.name = a || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      i.prototype = { push: function(a) {
        this.emit("data", a);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (a) {
          this.emit("error", a);
        }
        return !0;
      }, error: function(a) {
        return !this.isFinished && (this.isPaused ? this.generatedError = a : (this.isFinished = !0, this.emit("error", a), this.previous && this.previous.error(a), this.cleanUp()), !0);
      }, on: function(a, r) {
        return this._listeners[a].push(r), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(a, r) {
        if (this._listeners[a])
          for (var c = 0; c < this._listeners[a].length; c++)
            this._listeners[a][c].call(this, r);
      }, pipe: function(a) {
        return a.registerPrevious(this);
      }, registerPrevious: function(a) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = a.streamInfo, this.mergeStreamInfo(), this.previous = a;
        var r = this;
        return a.on("data", function(c) {
          r.processChunk(c);
        }), a.on("end", function() {
          r.end();
        }), a.on("error", function(c) {
          r.error(c);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var a = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), a = !0), this.previous && this.previous.resume(), !a;
      }, flush: function() {
      }, processChunk: function(a) {
        this.push(a);
      }, withStreamInfo: function(a, r) {
        return this.extraStreamInfo[a] = r, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var a in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, a) && (this.streamInfo[a] = this.extraStreamInfo[a]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var a = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + a : a;
      } }, o.exports = i;
    }, {}], 29: [function(e, o, n) {
      var i = e("../utils"), a = e("./ConvertWorker"), r = e("./GenericWorker"), c = e("../base64"), m = e("../support"), u = e("../external"), w = null;
      if (m.nodestream)
        try {
          w = e("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function g(v, h) {
        return new u.Promise(function(b, p) {
          var y = [], _ = v._internalType, S = v._outputType, D = v._mimeType;
          v.on("data", function(T, x) {
            y.push(T), h && h(x);
          }).on("error", function(T) {
            y = [], p(T);
          }).on("end", function() {
            try {
              var T = function(x, F, A) {
                switch (x) {
                  case "blob":
                    return i.newBlob(i.transformTo("arraybuffer", F), A);
                  case "base64":
                    return c.encode(F);
                  default:
                    return i.transformTo(x, F);
                }
              }(S, function(x, F) {
                var A, M = 0, V = null, I = 0;
                for (A = 0; A < F.length; A++)
                  I += F[A].length;
                switch (x) {
                  case "string":
                    return F.join("");
                  case "array":
                    return Array.prototype.concat.apply([], F);
                  case "uint8array":
                    for (V = new Uint8Array(I), A = 0; A < F.length; A++)
                      V.set(F[A], M), M += F[A].length;
                    return V;
                  case "nodebuffer":
                    return _t.Buffer.concat(F);
                  default:
                    throw new Error("concat : unsupported type '" + x + "'");
                }
              }(_, y), D);
              b(T);
            } catch (x) {
              p(x);
            }
            y = [];
          }).resume();
        });
      }
      function f(v, h, b) {
        var p = h;
        switch (h) {
          case "blob":
          case "arraybuffer":
            p = "uint8array";
            break;
          case "base64":
            p = "string";
        }
        try {
          this._internalType = p, this._outputType = h, this._mimeType = b, i.checkSupport(p), this._worker = v.pipe(new a(p)), v.lock();
        } catch (y) {
          this._worker = new r("error"), this._worker.error(y);
        }
      }
      f.prototype = { accumulate: function(v) {
        return g(this, v);
      }, on: function(v, h) {
        var b = this;
        return v === "data" ? this._worker.on(v, function(p) {
          h.call(b, p.data, p.meta);
        }) : this._worker.on(v, function() {
          i.delay(h, arguments, b);
        }), this;
      }, resume: function() {
        return i.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(v) {
        if (i.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new w(this, { objectMode: this._outputType !== "nodebuffer" }, v);
      } }, o.exports = f;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(e, o, n) {
      if (n.base64 = !0, n.array = !0, n.string = !0, n.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", n.nodebuffer = typeof _t.Buffer < "u", n.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        n.blob = !1;
      else {
        var i = new ArrayBuffer(0);
        try {
          n.blob = new Blob([i], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var a = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            a.append(i), n.blob = a.getBlob("application/zip").size === 0;
          } catch {
            n.blob = !1;
          }
        }
      }
      try {
        n.nodestream = !!e("readable-stream").Readable;
      } catch {
        n.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(e, o, n) {
      for (var i = e("./utils"), a = e("./support"), r = e("./nodejsUtils"), c = e("./stream/GenericWorker"), m = new Array(256), u = 0; u < 256; u++)
        m[u] = 252 <= u ? 6 : 248 <= u ? 5 : 240 <= u ? 4 : 224 <= u ? 3 : 192 <= u ? 2 : 1;
      m[254] = m[254] = 1;
      function w() {
        c.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function g() {
        c.call(this, "utf-8 encode");
      }
      n.utf8encode = function(f) {
        return a.nodebuffer ? r.newBufferFrom(f, "utf-8") : function(v) {
          var h, b, p, y, _, S = v.length, D = 0;
          for (y = 0; y < S; y++)
            (64512 & (b = v.charCodeAt(y))) == 55296 && y + 1 < S && (64512 & (p = v.charCodeAt(y + 1))) == 56320 && (b = 65536 + (b - 55296 << 10) + (p - 56320), y++), D += b < 128 ? 1 : b < 2048 ? 2 : b < 65536 ? 3 : 4;
          for (h = a.uint8array ? new Uint8Array(D) : new Array(D), y = _ = 0; _ < D; y++)
            (64512 & (b = v.charCodeAt(y))) == 55296 && y + 1 < S && (64512 & (p = v.charCodeAt(y + 1))) == 56320 && (b = 65536 + (b - 55296 << 10) + (p - 56320), y++), b < 128 ? h[_++] = b : (b < 2048 ? h[_++] = 192 | b >>> 6 : (b < 65536 ? h[_++] = 224 | b >>> 12 : (h[_++] = 240 | b >>> 18, h[_++] = 128 | b >>> 12 & 63), h[_++] = 128 | b >>> 6 & 63), h[_++] = 128 | 63 & b);
          return h;
        }(f);
      }, n.utf8decode = function(f) {
        return a.nodebuffer ? i.transformTo("nodebuffer", f).toString("utf-8") : function(v) {
          var h, b, p, y, _ = v.length, S = new Array(2 * _);
          for (h = b = 0; h < _; )
            if ((p = v[h++]) < 128)
              S[b++] = p;
            else if (4 < (y = m[p]))
              S[b++] = 65533, h += y - 1;
            else {
              for (p &= y === 2 ? 31 : y === 3 ? 15 : 7; 1 < y && h < _; )
                p = p << 6 | 63 & v[h++], y--;
              1 < y ? S[b++] = 65533 : p < 65536 ? S[b++] = p : (p -= 65536, S[b++] = 55296 | p >> 10 & 1023, S[b++] = 56320 | 1023 & p);
            }
          return S.length !== b && (S.subarray ? S = S.subarray(0, b) : S.length = b), i.applyFromCharCode(S);
        }(f = i.transformTo(a.uint8array ? "uint8array" : "array", f));
      }, i.inherits(w, c), w.prototype.processChunk = function(f) {
        var v = i.transformTo(a.uint8array ? "uint8array" : "array", f.data);
        if (this.leftOver && this.leftOver.length) {
          if (a.uint8array) {
            var h = v;
            (v = new Uint8Array(h.length + this.leftOver.length)).set(this.leftOver, 0), v.set(h, this.leftOver.length);
          } else
            v = this.leftOver.concat(v);
          this.leftOver = null;
        }
        var b = function(y, _) {
          var S;
          for ((_ = _ || y.length) > y.length && (_ = y.length), S = _ - 1; 0 <= S && (192 & y[S]) == 128; )
            S--;
          return S < 0 || S === 0 ? _ : S + m[y[S]] > _ ? S : _;
        }(v), p = v;
        b !== v.length && (a.uint8array ? (p = v.subarray(0, b), this.leftOver = v.subarray(b, v.length)) : (p = v.slice(0, b), this.leftOver = v.slice(b, v.length))), this.push({ data: n.utf8decode(p), meta: f.meta });
      }, w.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: n.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, n.Utf8DecodeWorker = w, i.inherits(g, c), g.prototype.processChunk = function(f) {
        this.push({ data: n.utf8encode(f.data), meta: f.meta });
      }, n.Utf8EncodeWorker = g;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(e, o, n) {
      var i = e("./support"), a = e("./base64"), r = e("./nodejsUtils"), c = e("./external");
      function m(h) {
        return h;
      }
      function u(h, b) {
        for (var p = 0; p < h.length; ++p)
          b[p] = 255 & h.charCodeAt(p);
        return b;
      }
      e("setimmediate"), n.newBlob = function(h, b) {
        n.checkSupport("blob");
        try {
          return new Blob([h], { type: b });
        } catch {
          try {
            var p = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return p.append(h), p.getBlob(b);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var w = { stringifyByChunk: function(h, b, p) {
        var y = [], _ = 0, S = h.length;
        if (S <= p)
          return String.fromCharCode.apply(null, h);
        for (; _ < S; )
          b === "array" || b === "nodebuffer" ? y.push(String.fromCharCode.apply(null, h.slice(_, Math.min(_ + p, S)))) : y.push(String.fromCharCode.apply(null, h.subarray(_, Math.min(_ + p, S)))), _ += p;
        return y.join("");
      }, stringifyByChar: function(h) {
        for (var b = "", p = 0; p < h.length; p++)
          b += String.fromCharCode(h[p]);
        return b;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return i.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return i.nodebuffer && String.fromCharCode.apply(null, r.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function g(h) {
        var b = 65536, p = n.getTypeOf(h), y = !0;
        if (p === "uint8array" ? y = w.applyCanBeUsed.uint8array : p === "nodebuffer" && (y = w.applyCanBeUsed.nodebuffer), y)
          for (; 1 < b; )
            try {
              return w.stringifyByChunk(h, p, b);
            } catch {
              b = Math.floor(b / 2);
            }
        return w.stringifyByChar(h);
      }
      function f(h, b) {
        for (var p = 0; p < h.length; p++)
          b[p] = h[p];
        return b;
      }
      n.applyFromCharCode = g;
      var v = {};
      v.string = { string: m, array: function(h) {
        return u(h, new Array(h.length));
      }, arraybuffer: function(h) {
        return v.string.uint8array(h).buffer;
      }, uint8array: function(h) {
        return u(h, new Uint8Array(h.length));
      }, nodebuffer: function(h) {
        return u(h, r.allocBuffer(h.length));
      } }, v.array = { string: g, array: m, arraybuffer: function(h) {
        return new Uint8Array(h).buffer;
      }, uint8array: function(h) {
        return new Uint8Array(h);
      }, nodebuffer: function(h) {
        return r.newBufferFrom(h);
      } }, v.arraybuffer = { string: function(h) {
        return g(new Uint8Array(h));
      }, array: function(h) {
        return f(new Uint8Array(h), new Array(h.byteLength));
      }, arraybuffer: m, uint8array: function(h) {
        return new Uint8Array(h);
      }, nodebuffer: function(h) {
        return r.newBufferFrom(new Uint8Array(h));
      } }, v.uint8array = { string: g, array: function(h) {
        return f(h, new Array(h.length));
      }, arraybuffer: function(h) {
        return h.buffer;
      }, uint8array: m, nodebuffer: function(h) {
        return r.newBufferFrom(h);
      } }, v.nodebuffer = { string: g, array: function(h) {
        return f(h, new Array(h.length));
      }, arraybuffer: function(h) {
        return v.nodebuffer.uint8array(h).buffer;
      }, uint8array: function(h) {
        return f(h, new Uint8Array(h.length));
      }, nodebuffer: m }, n.transformTo = function(h, b) {
        if (b = b || "", !h)
          return b;
        n.checkSupport(h);
        var p = n.getTypeOf(b);
        return v[p][h](b);
      }, n.resolve = function(h) {
        for (var b = h.split("/"), p = [], y = 0; y < b.length; y++) {
          var _ = b[y];
          _ === "." || _ === "" && y !== 0 && y !== b.length - 1 || (_ === ".." ? p.pop() : p.push(_));
        }
        return p.join("/");
      }, n.getTypeOf = function(h) {
        return typeof h == "string" ? "string" : Object.prototype.toString.call(h) === "[object Array]" ? "array" : i.nodebuffer && r.isBuffer(h) ? "nodebuffer" : i.uint8array && h instanceof Uint8Array ? "uint8array" : i.arraybuffer && h instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, n.checkSupport = function(h) {
        if (!i[h.toLowerCase()])
          throw new Error(h + " is not supported by this platform");
      }, n.MAX_VALUE_16BITS = 65535, n.MAX_VALUE_32BITS = -1, n.pretty = function(h) {
        var b, p, y = "";
        for (p = 0; p < (h || "").length; p++)
          y += "\\x" + ((b = h.charCodeAt(p)) < 16 ? "0" : "") + b.toString(16).toUpperCase();
        return y;
      }, n.delay = function(h, b, p) {
        setImmediate(function() {
          h.apply(p || null, b || []);
        });
      }, n.inherits = function(h, b) {
        function p() {
        }
        p.prototype = b.prototype, h.prototype = new p();
      }, n.extend = function() {
        var h, b, p = {};
        for (h = 0; h < arguments.length; h++)
          for (b in arguments[h])
            Object.prototype.hasOwnProperty.call(arguments[h], b) && p[b] === void 0 && (p[b] = arguments[h][b]);
        return p;
      }, n.prepareContent = function(h, b, p, y, _) {
        return c.Promise.resolve(b).then(function(S) {
          return i.blob && (S instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(S)) !== -1) && typeof FileReader < "u" ? new c.Promise(function(D, T) {
            var x = new FileReader();
            x.onload = function(F) {
              D(F.target.result);
            }, x.onerror = function(F) {
              T(F.target.error);
            }, x.readAsArrayBuffer(S);
          }) : S;
        }).then(function(S) {
          var D = n.getTypeOf(S);
          return D ? (D === "arraybuffer" ? S = n.transformTo("uint8array", S) : D === "string" && (_ ? S = a.decode(S) : p && y !== !0 && (S = function(T) {
            return u(T, i.uint8array ? new Uint8Array(T.length) : new Array(T.length));
          }(S))), S) : c.Promise.reject(new Error("Can't read the data of '" + h + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(e, o, n) {
      var i = e("./reader/readerFor"), a = e("./utils"), r = e("./signature"), c = e("./zipEntry"), m = e("./support");
      function u(w) {
        this.files = [], this.loadOptions = w;
      }
      u.prototype = { checkSignature: function(w) {
        if (!this.reader.readAndCheckSignature(w)) {
          this.reader.index -= 4;
          var g = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + a.pretty(g) + ", expected " + a.pretty(w) + ")");
        }
      }, isSignature: function(w, g) {
        var f = this.reader.index;
        this.reader.setIndex(w);
        var v = this.reader.readString(4) === g;
        return this.reader.setIndex(f), v;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var w = this.reader.readData(this.zipCommentLength), g = m.uint8array ? "uint8array" : "array", f = a.transformTo(g, w);
        this.zipComment = this.loadOptions.decodeFileName(f);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var w, g, f, v = this.zip64EndOfCentralSize - 44; 0 < v; )
          w = this.reader.readInt(2), g = this.reader.readInt(4), f = this.reader.readData(g), this.zip64ExtensibleData[w] = { id: w, length: g, value: f };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var w, g;
        for (w = 0; w < this.files.length; w++)
          g = this.files[w], this.reader.setIndex(g.localHeaderOffset), this.checkSignature(r.LOCAL_FILE_HEADER), g.readLocalPart(this.reader), g.handleUTF8(), g.processAttributes();
      }, readCentralDir: function() {
        var w;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(r.CENTRAL_FILE_HEADER); )
          (w = new c({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(w);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var w = this.reader.lastIndexOfSignature(r.CENTRAL_DIRECTORY_END);
        if (w < 0)
          throw this.isSignature(0, r.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(w);
        var g = w;
        if (this.checkSignature(r.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === a.MAX_VALUE_16BITS || this.diskWithCentralDirStart === a.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === a.MAX_VALUE_16BITS || this.centralDirRecords === a.MAX_VALUE_16BITS || this.centralDirSize === a.MAX_VALUE_32BITS || this.centralDirOffset === a.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (w = this.reader.lastIndexOfSignature(r.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(w), this.checkSignature(r.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, r.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(r.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(r.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var f = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (f += 20, f += 12 + this.zip64EndOfCentralSize);
        var v = g - f;
        if (0 < v)
          this.isSignature(g, r.CENTRAL_FILE_HEADER) || (this.reader.zero = v);
        else if (v < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(v) + " bytes.");
      }, prepareReader: function(w) {
        this.reader = i(w);
      }, load: function(w) {
        this.prepareReader(w), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, o.exports = u;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(e, o, n) {
      var i = e("./reader/readerFor"), a = e("./utils"), r = e("./compressedObject"), c = e("./crc32"), m = e("./utf8"), u = e("./compressions"), w = e("./support");
      function g(f, v) {
        this.options = f, this.loadOptions = v;
      }
      g.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(f) {
        var v, h;
        if (f.skip(22), this.fileNameLength = f.readInt(2), h = f.readInt(2), this.fileName = f.readData(this.fileNameLength), f.skip(h), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((v = function(b) {
          for (var p in u)
            if (Object.prototype.hasOwnProperty.call(u, p) && u[p].magic === b)
              return u[p];
          return null;
        }(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + a.pretty(this.compressionMethod) + " unknown (inner file : " + a.transformTo("string", this.fileName) + ")");
        this.decompressed = new r(this.compressedSize, this.uncompressedSize, this.crc32, v, f.readData(this.compressedSize));
      }, readCentralPart: function(f) {
        this.versionMadeBy = f.readInt(2), f.skip(2), this.bitFlag = f.readInt(2), this.compressionMethod = f.readString(2), this.date = f.readDate(), this.crc32 = f.readInt(4), this.compressedSize = f.readInt(4), this.uncompressedSize = f.readInt(4);
        var v = f.readInt(2);
        if (this.extraFieldsLength = f.readInt(2), this.fileCommentLength = f.readInt(2), this.diskNumberStart = f.readInt(2), this.internalFileAttributes = f.readInt(2), this.externalFileAttributes = f.readInt(4), this.localHeaderOffset = f.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        f.skip(v), this.readExtraFields(f), this.parseZIP64ExtraField(f), this.fileComment = f.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var f = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), f == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), f == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var f = i(this.extraFields[1].value);
          this.uncompressedSize === a.MAX_VALUE_32BITS && (this.uncompressedSize = f.readInt(8)), this.compressedSize === a.MAX_VALUE_32BITS && (this.compressedSize = f.readInt(8)), this.localHeaderOffset === a.MAX_VALUE_32BITS && (this.localHeaderOffset = f.readInt(8)), this.diskNumberStart === a.MAX_VALUE_32BITS && (this.diskNumberStart = f.readInt(4));
        }
      }, readExtraFields: function(f) {
        var v, h, b, p = f.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); f.index + 4 < p; )
          v = f.readInt(2), h = f.readInt(2), b = f.readData(h), this.extraFields[v] = { id: v, length: h, value: b };
        f.setIndex(p);
      }, handleUTF8: function() {
        var f = w.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = m.utf8decode(this.fileName), this.fileCommentStr = m.utf8decode(this.fileComment);
        else {
          var v = this.findExtraFieldUnicodePath();
          if (v !== null)
            this.fileNameStr = v;
          else {
            var h = a.transformTo(f, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(h);
          }
          var b = this.findExtraFieldUnicodeComment();
          if (b !== null)
            this.fileCommentStr = b;
          else {
            var p = a.transformTo(f, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(p);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var f = this.extraFields[28789];
        if (f) {
          var v = i(f.value);
          return v.readInt(1) !== 1 || c(this.fileName) !== v.readInt(4) ? null : m.utf8decode(v.readData(f.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var f = this.extraFields[25461];
        if (f) {
          var v = i(f.value);
          return v.readInt(1) !== 1 || c(this.fileComment) !== v.readInt(4) ? null : m.utf8decode(v.readData(f.length - 5));
        }
        return null;
      } }, o.exports = g;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(e, o, n) {
      function i(v, h, b) {
        this.name = v, this.dir = b.dir, this.date = b.date, this.comment = b.comment, this.unixPermissions = b.unixPermissions, this.dosPermissions = b.dosPermissions, this._data = h, this._dataBinary = b.binary, this.options = { compression: b.compression, compressionOptions: b.compressionOptions };
      }
      var a = e("./stream/StreamHelper"), r = e("./stream/DataWorker"), c = e("./utf8"), m = e("./compressedObject"), u = e("./stream/GenericWorker");
      i.prototype = { internalStream: function(v) {
        var h = null, b = "string";
        try {
          if (!v)
            throw new Error("No output type specified.");
          var p = (b = v.toLowerCase()) === "string" || b === "text";
          b !== "binarystring" && b !== "text" || (b = "string"), h = this._decompressWorker();
          var y = !this._dataBinary;
          y && !p && (h = h.pipe(new c.Utf8EncodeWorker())), !y && p && (h = h.pipe(new c.Utf8DecodeWorker()));
        } catch (_) {
          (h = new u("error")).error(_);
        }
        return new a(h, b, "");
      }, async: function(v, h) {
        return this.internalStream(v).accumulate(h);
      }, nodeStream: function(v, h) {
        return this.internalStream(v || "nodebuffer").toNodejsStream(h);
      }, _compressWorker: function(v, h) {
        if (this._data instanceof m && this._data.compression.magic === v.magic)
          return this._data.getCompressedWorker();
        var b = this._decompressWorker();
        return this._dataBinary || (b = b.pipe(new c.Utf8EncodeWorker())), m.createWorkerFrom(b, v, h);
      }, _decompressWorker: function() {
        return this._data instanceof m ? this._data.getContentWorker() : this._data instanceof u ? this._data : new r(this._data);
      } };
      for (var w = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], g = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, f = 0; f < w.length; f++)
        i.prototype[w[f]] = g;
      o.exports = i;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(e, o, n) {
      (function(i) {
        var a, r, c = i.MutationObserver || i.WebKitMutationObserver;
        if (c) {
          var m = 0, u = new c(v), w = i.document.createTextNode("");
          u.observe(w, { characterData: !0 }), a = function() {
            w.data = m = ++m % 2;
          };
        } else if (i.setImmediate || i.MessageChannel === void 0)
          a = "document" in i && "onreadystatechange" in i.document.createElement("script") ? function() {
            var h = i.document.createElement("script");
            h.onreadystatechange = function() {
              v(), h.onreadystatechange = null, h.parentNode.removeChild(h), h = null;
            }, i.document.documentElement.appendChild(h);
          } : function() {
            setTimeout(v, 0);
          };
        else {
          var g = new i.MessageChannel();
          g.port1.onmessage = v, a = function() {
            g.port2.postMessage(0);
          };
        }
        var f = [];
        function v() {
          var h, b;
          r = !0;
          for (var p = f.length; p; ) {
            for (b = f, f = [], h = -1; ++h < p; )
              b[h]();
            p = f.length;
          }
          r = !1;
        }
        o.exports = function(h) {
          f.push(h) !== 1 || r || a();
        };
      }).call(this, typeof Mt < "u" ? Mt : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(e, o, n) {
      var i = e("immediate");
      function a() {
      }
      var r = {}, c = ["REJECTED"], m = ["FULFILLED"], u = ["PENDING"];
      function w(p) {
        if (typeof p != "function")
          throw new TypeError("resolver must be a function");
        this.state = u, this.queue = [], this.outcome = void 0, p !== a && h(this, p);
      }
      function g(p, y, _) {
        this.promise = p, typeof y == "function" && (this.onFulfilled = y, this.callFulfilled = this.otherCallFulfilled), typeof _ == "function" && (this.onRejected = _, this.callRejected = this.otherCallRejected);
      }
      function f(p, y, _) {
        i(function() {
          var S;
          try {
            S = y(_);
          } catch (D) {
            return r.reject(p, D);
          }
          S === p ? r.reject(p, new TypeError("Cannot resolve promise with itself")) : r.resolve(p, S);
        });
      }
      function v(p) {
        var y = p && p.then;
        if (p && (typeof p == "object" || typeof p == "function") && typeof y == "function")
          return function() {
            y.apply(p, arguments);
          };
      }
      function h(p, y) {
        var _ = !1;
        function S(x) {
          _ || (_ = !0, r.reject(p, x));
        }
        function D(x) {
          _ || (_ = !0, r.resolve(p, x));
        }
        var T = b(function() {
          y(D, S);
        });
        T.status === "error" && S(T.value);
      }
      function b(p, y) {
        var _ = {};
        try {
          _.value = p(y), _.status = "success";
        } catch (S) {
          _.status = "error", _.value = S;
        }
        return _;
      }
      (o.exports = w).prototype.finally = function(p) {
        if (typeof p != "function")
          return this;
        var y = this.constructor;
        return this.then(function(_) {
          return y.resolve(p()).then(function() {
            return _;
          });
        }, function(_) {
          return y.resolve(p()).then(function() {
            throw _;
          });
        });
      }, w.prototype.catch = function(p) {
        return this.then(null, p);
      }, w.prototype.then = function(p, y) {
        if (typeof p != "function" && this.state === m || typeof y != "function" && this.state === c)
          return this;
        var _ = new this.constructor(a);
        return this.state !== u ? f(_, this.state === m ? p : y, this.outcome) : this.queue.push(new g(_, p, y)), _;
      }, g.prototype.callFulfilled = function(p) {
        r.resolve(this.promise, p);
      }, g.prototype.otherCallFulfilled = function(p) {
        f(this.promise, this.onFulfilled, p);
      }, g.prototype.callRejected = function(p) {
        r.reject(this.promise, p);
      }, g.prototype.otherCallRejected = function(p) {
        f(this.promise, this.onRejected, p);
      }, r.resolve = function(p, y) {
        var _ = b(v, y);
        if (_.status === "error")
          return r.reject(p, _.value);
        var S = _.value;
        if (S)
          h(p, S);
        else {
          p.state = m, p.outcome = y;
          for (var D = -1, T = p.queue.length; ++D < T; )
            p.queue[D].callFulfilled(y);
        }
        return p;
      }, r.reject = function(p, y) {
        p.state = c, p.outcome = y;
        for (var _ = -1, S = p.queue.length; ++_ < S; )
          p.queue[_].callRejected(y);
        return p;
      }, w.resolve = function(p) {
        return p instanceof this ? p : r.resolve(new this(a), p);
      }, w.reject = function(p) {
        var y = new this(a);
        return r.reject(y, p);
      }, w.all = function(p) {
        var y = this;
        if (Object.prototype.toString.call(p) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var _ = p.length, S = !1;
        if (!_)
          return this.resolve([]);
        for (var D = new Array(_), T = 0, x = -1, F = new this(a); ++x < _; )
          A(p[x], x);
        return F;
        function A(M, V) {
          y.resolve(M).then(function(I) {
            D[V] = I, ++T !== _ || S || (S = !0, r.resolve(F, D));
          }, function(I) {
            S || (S = !0, r.reject(F, I));
          });
        }
      }, w.race = function(p) {
        var y = this;
        if (Object.prototype.toString.call(p) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var _ = p.length, S = !1;
        if (!_)
          return this.resolve([]);
        for (var D = -1, T = new this(a); ++D < _; )
          x = p[D], y.resolve(x).then(function(F) {
            S || (S = !0, r.resolve(T, F));
          }, function(F) {
            S || (S = !0, r.reject(T, F));
          });
        var x;
        return T;
      };
    }, { immediate: 36 }], 38: [function(e, o, n) {
      var i = {};
      (0, e("./lib/utils/common").assign)(i, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), o.exports = i;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(e, o, n) {
      var i = e("./zlib/deflate"), a = e("./utils/common"), r = e("./utils/strings"), c = e("./zlib/messages"), m = e("./zlib/zstream"), u = Object.prototype.toString, w = 0, g = -1, f = 0, v = 8;
      function h(p) {
        if (!(this instanceof h))
          return new h(p);
        this.options = a.assign({ level: g, method: v, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: f, to: "" }, p || {});
        var y = this.options;
        y.raw && 0 < y.windowBits ? y.windowBits = -y.windowBits : y.gzip && 0 < y.windowBits && y.windowBits < 16 && (y.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new m(), this.strm.avail_out = 0;
        var _ = i.deflateInit2(this.strm, y.level, y.method, y.windowBits, y.memLevel, y.strategy);
        if (_ !== w)
          throw new Error(c[_]);
        if (y.header && i.deflateSetHeader(this.strm, y.header), y.dictionary) {
          var S;
          if (S = typeof y.dictionary == "string" ? r.string2buf(y.dictionary) : u.call(y.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(y.dictionary) : y.dictionary, (_ = i.deflateSetDictionary(this.strm, S)) !== w)
            throw new Error(c[_]);
          this._dict_set = !0;
        }
      }
      function b(p, y) {
        var _ = new h(y);
        if (_.push(p, !0), _.err)
          throw _.msg || c[_.err];
        return _.result;
      }
      h.prototype.push = function(p, y) {
        var _, S, D = this.strm, T = this.options.chunkSize;
        if (this.ended)
          return !1;
        S = y === ~~y ? y : y === !0 ? 4 : 0, typeof p == "string" ? D.input = r.string2buf(p) : u.call(p) === "[object ArrayBuffer]" ? D.input = new Uint8Array(p) : D.input = p, D.next_in = 0, D.avail_in = D.input.length;
        do {
          if (D.avail_out === 0 && (D.output = new a.Buf8(T), D.next_out = 0, D.avail_out = T), (_ = i.deflate(D, S)) !== 1 && _ !== w)
            return this.onEnd(_), !(this.ended = !0);
          D.avail_out !== 0 && (D.avail_in !== 0 || S !== 4 && S !== 2) || (this.options.to === "string" ? this.onData(r.buf2binstring(a.shrinkBuf(D.output, D.next_out))) : this.onData(a.shrinkBuf(D.output, D.next_out)));
        } while ((0 < D.avail_in || D.avail_out === 0) && _ !== 1);
        return S === 4 ? (_ = i.deflateEnd(this.strm), this.onEnd(_), this.ended = !0, _ === w) : S !== 2 || (this.onEnd(w), !(D.avail_out = 0));
      }, h.prototype.onData = function(p) {
        this.chunks.push(p);
      }, h.prototype.onEnd = function(p) {
        p === w && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = a.flattenChunks(this.chunks)), this.chunks = [], this.err = p, this.msg = this.strm.msg;
      }, n.Deflate = h, n.deflate = b, n.deflateRaw = function(p, y) {
        return (y = y || {}).raw = !0, b(p, y);
      }, n.gzip = function(p, y) {
        return (y = y || {}).gzip = !0, b(p, y);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(e, o, n) {
      var i = e("./zlib/inflate"), a = e("./utils/common"), r = e("./utils/strings"), c = e("./zlib/constants"), m = e("./zlib/messages"), u = e("./zlib/zstream"), w = e("./zlib/gzheader"), g = Object.prototype.toString;
      function f(h) {
        if (!(this instanceof f))
          return new f(h);
        this.options = a.assign({ chunkSize: 16384, windowBits: 0, to: "" }, h || {});
        var b = this.options;
        b.raw && 0 <= b.windowBits && b.windowBits < 16 && (b.windowBits = -b.windowBits, b.windowBits === 0 && (b.windowBits = -15)), !(0 <= b.windowBits && b.windowBits < 16) || h && h.windowBits || (b.windowBits += 32), 15 < b.windowBits && b.windowBits < 48 && !(15 & b.windowBits) && (b.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new u(), this.strm.avail_out = 0;
        var p = i.inflateInit2(this.strm, b.windowBits);
        if (p !== c.Z_OK)
          throw new Error(m[p]);
        this.header = new w(), i.inflateGetHeader(this.strm, this.header);
      }
      function v(h, b) {
        var p = new f(b);
        if (p.push(h, !0), p.err)
          throw p.msg || m[p.err];
        return p.result;
      }
      f.prototype.push = function(h, b) {
        var p, y, _, S, D, T, x = this.strm, F = this.options.chunkSize, A = this.options.dictionary, M = !1;
        if (this.ended)
          return !1;
        y = b === ~~b ? b : b === !0 ? c.Z_FINISH : c.Z_NO_FLUSH, typeof h == "string" ? x.input = r.binstring2buf(h) : g.call(h) === "[object ArrayBuffer]" ? x.input = new Uint8Array(h) : x.input = h, x.next_in = 0, x.avail_in = x.input.length;
        do {
          if (x.avail_out === 0 && (x.output = new a.Buf8(F), x.next_out = 0, x.avail_out = F), (p = i.inflate(x, c.Z_NO_FLUSH)) === c.Z_NEED_DICT && A && (T = typeof A == "string" ? r.string2buf(A) : g.call(A) === "[object ArrayBuffer]" ? new Uint8Array(A) : A, p = i.inflateSetDictionary(this.strm, T)), p === c.Z_BUF_ERROR && M === !0 && (p = c.Z_OK, M = !1), p !== c.Z_STREAM_END && p !== c.Z_OK)
            return this.onEnd(p), !(this.ended = !0);
          x.next_out && (x.avail_out !== 0 && p !== c.Z_STREAM_END && (x.avail_in !== 0 || y !== c.Z_FINISH && y !== c.Z_SYNC_FLUSH) || (this.options.to === "string" ? (_ = r.utf8border(x.output, x.next_out), S = x.next_out - _, D = r.buf2string(x.output, _), x.next_out = S, x.avail_out = F - S, S && a.arraySet(x.output, x.output, _, S, 0), this.onData(D)) : this.onData(a.shrinkBuf(x.output, x.next_out)))), x.avail_in === 0 && x.avail_out === 0 && (M = !0);
        } while ((0 < x.avail_in || x.avail_out === 0) && p !== c.Z_STREAM_END);
        return p === c.Z_STREAM_END && (y = c.Z_FINISH), y === c.Z_FINISH ? (p = i.inflateEnd(this.strm), this.onEnd(p), this.ended = !0, p === c.Z_OK) : y !== c.Z_SYNC_FLUSH || (this.onEnd(c.Z_OK), !(x.avail_out = 0));
      }, f.prototype.onData = function(h) {
        this.chunks.push(h);
      }, f.prototype.onEnd = function(h) {
        h === c.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = a.flattenChunks(this.chunks)), this.chunks = [], this.err = h, this.msg = this.strm.msg;
      }, n.Inflate = f, n.inflate = v, n.inflateRaw = function(h, b) {
        return (b = b || {}).raw = !0, v(h, b);
      }, n.ungzip = v;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(e, o, n) {
      var i = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      n.assign = function(c) {
        for (var m = Array.prototype.slice.call(arguments, 1); m.length; ) {
          var u = m.shift();
          if (u) {
            if (typeof u != "object")
              throw new TypeError(u + "must be non-object");
            for (var w in u)
              u.hasOwnProperty(w) && (c[w] = u[w]);
          }
        }
        return c;
      }, n.shrinkBuf = function(c, m) {
        return c.length === m ? c : c.subarray ? c.subarray(0, m) : (c.length = m, c);
      };
      var a = { arraySet: function(c, m, u, w, g) {
        if (m.subarray && c.subarray)
          c.set(m.subarray(u, u + w), g);
        else
          for (var f = 0; f < w; f++)
            c[g + f] = m[u + f];
      }, flattenChunks: function(c) {
        var m, u, w, g, f, v;
        for (m = w = 0, u = c.length; m < u; m++)
          w += c[m].length;
        for (v = new Uint8Array(w), m = g = 0, u = c.length; m < u; m++)
          f = c[m], v.set(f, g), g += f.length;
        return v;
      } }, r = { arraySet: function(c, m, u, w, g) {
        for (var f = 0; f < w; f++)
          c[g + f] = m[u + f];
      }, flattenChunks: function(c) {
        return [].concat.apply([], c);
      } };
      n.setTyped = function(c) {
        c ? (n.Buf8 = Uint8Array, n.Buf16 = Uint16Array, n.Buf32 = Int32Array, n.assign(n, a)) : (n.Buf8 = Array, n.Buf16 = Array, n.Buf32 = Array, n.assign(n, r));
      }, n.setTyped(i);
    }, {}], 42: [function(e, o, n) {
      var i = e("./common"), a = !0, r = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        a = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        r = !1;
      }
      for (var c = new i.Buf8(256), m = 0; m < 256; m++)
        c[m] = 252 <= m ? 6 : 248 <= m ? 5 : 240 <= m ? 4 : 224 <= m ? 3 : 192 <= m ? 2 : 1;
      function u(w, g) {
        if (g < 65537 && (w.subarray && r || !w.subarray && a))
          return String.fromCharCode.apply(null, i.shrinkBuf(w, g));
        for (var f = "", v = 0; v < g; v++)
          f += String.fromCharCode(w[v]);
        return f;
      }
      c[254] = c[254] = 1, n.string2buf = function(w) {
        var g, f, v, h, b, p = w.length, y = 0;
        for (h = 0; h < p; h++)
          (64512 & (f = w.charCodeAt(h))) == 55296 && h + 1 < p && (64512 & (v = w.charCodeAt(h + 1))) == 56320 && (f = 65536 + (f - 55296 << 10) + (v - 56320), h++), y += f < 128 ? 1 : f < 2048 ? 2 : f < 65536 ? 3 : 4;
        for (g = new i.Buf8(y), h = b = 0; b < y; h++)
          (64512 & (f = w.charCodeAt(h))) == 55296 && h + 1 < p && (64512 & (v = w.charCodeAt(h + 1))) == 56320 && (f = 65536 + (f - 55296 << 10) + (v - 56320), h++), f < 128 ? g[b++] = f : (f < 2048 ? g[b++] = 192 | f >>> 6 : (f < 65536 ? g[b++] = 224 | f >>> 12 : (g[b++] = 240 | f >>> 18, g[b++] = 128 | f >>> 12 & 63), g[b++] = 128 | f >>> 6 & 63), g[b++] = 128 | 63 & f);
        return g;
      }, n.buf2binstring = function(w) {
        return u(w, w.length);
      }, n.binstring2buf = function(w) {
        for (var g = new i.Buf8(w.length), f = 0, v = g.length; f < v; f++)
          g[f] = w.charCodeAt(f);
        return g;
      }, n.buf2string = function(w, g) {
        var f, v, h, b, p = g || w.length, y = new Array(2 * p);
        for (f = v = 0; f < p; )
          if ((h = w[f++]) < 128)
            y[v++] = h;
          else if (4 < (b = c[h]))
            y[v++] = 65533, f += b - 1;
          else {
            for (h &= b === 2 ? 31 : b === 3 ? 15 : 7; 1 < b && f < p; )
              h = h << 6 | 63 & w[f++], b--;
            1 < b ? y[v++] = 65533 : h < 65536 ? y[v++] = h : (h -= 65536, y[v++] = 55296 | h >> 10 & 1023, y[v++] = 56320 | 1023 & h);
          }
        return u(y, v);
      }, n.utf8border = function(w, g) {
        var f;
        for ((g = g || w.length) > w.length && (g = w.length), f = g - 1; 0 <= f && (192 & w[f]) == 128; )
          f--;
        return f < 0 || f === 0 ? g : f + c[w[f]] > g ? f : g;
      };
    }, { "./common": 41 }], 43: [function(e, o, n) {
      o.exports = function(i, a, r, c) {
        for (var m = 65535 & i | 0, u = i >>> 16 & 65535 | 0, w = 0; r !== 0; ) {
          for (r -= w = 2e3 < r ? 2e3 : r; u = u + (m = m + a[c++] | 0) | 0, --w; )
            ;
          m %= 65521, u %= 65521;
        }
        return m | u << 16 | 0;
      };
    }, {}], 44: [function(e, o, n) {
      o.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(e, o, n) {
      var i = function() {
        for (var a, r = [], c = 0; c < 256; c++) {
          a = c;
          for (var m = 0; m < 8; m++)
            a = 1 & a ? 3988292384 ^ a >>> 1 : a >>> 1;
          r[c] = a;
        }
        return r;
      }();
      o.exports = function(a, r, c, m) {
        var u = i, w = m + c;
        a ^= -1;
        for (var g = m; g < w; g++)
          a = a >>> 8 ^ u[255 & (a ^ r[g])];
        return -1 ^ a;
      };
    }, {}], 46: [function(e, o, n) {
      var i, a = e("../utils/common"), r = e("./trees"), c = e("./adler32"), m = e("./crc32"), u = e("./messages"), w = 0, g = 4, f = 0, v = -2, h = -1, b = 4, p = 2, y = 8, _ = 9, S = 286, D = 30, T = 19, x = 2 * S + 1, F = 15, A = 3, M = 258, V = M + A + 1, I = 42, O = 113, l = 1, P = 2, et = 3, L = 4;
      function ot(d, z) {
        return d.msg = u[z], z;
      }
      function K(d) {
        return (d << 1) - (4 < d ? 9 : 0);
      }
      function tt(d) {
        for (var z = d.length; 0 <= --z; )
          d[z] = 0;
      }
      function j(d) {
        var z = d.state, J = z.pending;
        J > d.avail_out && (J = d.avail_out), J !== 0 && (a.arraySet(d.output, z.pending_buf, z.pending_out, J, d.next_out), d.next_out += J, z.pending_out += J, d.total_out += J, d.avail_out -= J, z.pending -= J, z.pending === 0 && (z.pending_out = 0));
      }
      function R(d, z) {
        r._tr_flush_block(d, 0 <= d.block_start ? d.block_start : -1, d.strstart - d.block_start, z), d.block_start = d.strstart, j(d.strm);
      }
      function Q(d, z) {
        d.pending_buf[d.pending++] = z;
      }
      function Z(d, z) {
        d.pending_buf[d.pending++] = z >>> 8 & 255, d.pending_buf[d.pending++] = 255 & z;
      }
      function H(d, z) {
        var J, k, C = d.max_chain_length, N = d.strstart, $ = d.prev_length, U = d.nice_match, E = d.strstart > d.w_size - V ? d.strstart - (d.w_size - V) : 0, B = d.window, W = d.w_mask, q = d.prev, Y = d.strstart + M, st = B[N + $ - 1], it = B[N + $];
        d.prev_length >= d.good_match && (C >>= 2), U > d.lookahead && (U = d.lookahead);
        do
          if (B[(J = z) + $] === it && B[J + $ - 1] === st && B[J] === B[N] && B[++J] === B[N + 1]) {
            N += 2, J++;
            do
              ;
            while (B[++N] === B[++J] && B[++N] === B[++J] && B[++N] === B[++J] && B[++N] === B[++J] && B[++N] === B[++J] && B[++N] === B[++J] && B[++N] === B[++J] && B[++N] === B[++J] && N < Y);
            if (k = M - (Y - N), N = Y - M, $ < k) {
              if (d.match_start = z, U <= ($ = k))
                break;
              st = B[N + $ - 1], it = B[N + $];
            }
          }
        while ((z = q[z & W]) > E && --C != 0);
        return $ <= d.lookahead ? $ : d.lookahead;
      }
      function ct(d) {
        var z, J, k, C, N, $, U, E, B, W, q = d.w_size;
        do {
          if (C = d.window_size - d.lookahead - d.strstart, d.strstart >= q + (q - V)) {
            for (a.arraySet(d.window, d.window, q, q, 0), d.match_start -= q, d.strstart -= q, d.block_start -= q, z = J = d.hash_size; k = d.head[--z], d.head[z] = q <= k ? k - q : 0, --J; )
              ;
            for (z = J = q; k = d.prev[--z], d.prev[z] = q <= k ? k - q : 0, --J; )
              ;
            C += q;
          }
          if (d.strm.avail_in === 0)
            break;
          if ($ = d.strm, U = d.window, E = d.strstart + d.lookahead, B = C, W = void 0, W = $.avail_in, B < W && (W = B), J = W === 0 ? 0 : ($.avail_in -= W, a.arraySet(U, $.input, $.next_in, W, E), $.state.wrap === 1 ? $.adler = c($.adler, U, W, E) : $.state.wrap === 2 && ($.adler = m($.adler, U, W, E)), $.next_in += W, $.total_in += W, W), d.lookahead += J, d.lookahead + d.insert >= A)
            for (N = d.strstart - d.insert, d.ins_h = d.window[N], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[N + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[N + A - 1]) & d.hash_mask, d.prev[N & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = N, N++, d.insert--, !(d.lookahead + d.insert < A)); )
              ;
        } while (d.lookahead < V && d.strm.avail_in !== 0);
      }
      function wt(d, z) {
        for (var J, k; ; ) {
          if (d.lookahead < V) {
            if (ct(d), d.lookahead < V && z === w)
              return l;
            if (d.lookahead === 0)
              break;
          }
          if (J = 0, d.lookahead >= A && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + A - 1]) & d.hash_mask, J = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), J !== 0 && d.strstart - J <= d.w_size - V && (d.match_length = H(d, J)), d.match_length >= A)
            if (k = r._tr_tally(d, d.strstart - d.match_start, d.match_length - A), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= A) {
              for (d.match_length--; d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + A - 1]) & d.hash_mask, J = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart, --d.match_length != 0; )
                ;
              d.strstart++;
            } else
              d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
          else
            k = r._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
          if (k && (R(d, !1), d.strm.avail_out === 0))
            return l;
        }
        return d.insert = d.strstart < A - 1 ? d.strstart : A - 1, z === g ? (R(d, !0), d.strm.avail_out === 0 ? et : L) : d.last_lit && (R(d, !1), d.strm.avail_out === 0) ? l : P;
      }
      function nt(d, z) {
        for (var J, k, C; ; ) {
          if (d.lookahead < V) {
            if (ct(d), d.lookahead < V && z === w)
              return l;
            if (d.lookahead === 0)
              break;
          }
          if (J = 0, d.lookahead >= A && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + A - 1]) & d.hash_mask, J = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = A - 1, J !== 0 && d.prev_length < d.max_lazy_match && d.strstart - J <= d.w_size - V && (d.match_length = H(d, J), d.match_length <= 5 && (d.strategy === 1 || d.match_length === A && 4096 < d.strstart - d.match_start) && (d.match_length = A - 1)), d.prev_length >= A && d.match_length <= d.prev_length) {
            for (C = d.strstart + d.lookahead - A, k = r._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - A), d.lookahead -= d.prev_length - 1, d.prev_length -= 2; ++d.strstart <= C && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + A - 1]) & d.hash_mask, J = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), --d.prev_length != 0; )
              ;
            if (d.match_available = 0, d.match_length = A - 1, d.strstart++, k && (R(d, !1), d.strm.avail_out === 0))
              return l;
          } else if (d.match_available) {
            if ((k = r._tr_tally(d, 0, d.window[d.strstart - 1])) && R(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
              return l;
          } else
            d.match_available = 1, d.strstart++, d.lookahead--;
        }
        return d.match_available && (k = r._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < A - 1 ? d.strstart : A - 1, z === g ? (R(d, !0), d.strm.avail_out === 0 ? et : L) : d.last_lit && (R(d, !1), d.strm.avail_out === 0) ? l : P;
      }
      function rt(d, z, J, k, C) {
        this.good_length = d, this.max_lazy = z, this.nice_length = J, this.max_chain = k, this.func = C;
      }
      function ht() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = y, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new a.Buf16(2 * x), this.dyn_dtree = new a.Buf16(2 * (2 * D + 1)), this.bl_tree = new a.Buf16(2 * (2 * T + 1)), tt(this.dyn_ltree), tt(this.dyn_dtree), tt(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new a.Buf16(F + 1), this.heap = new a.Buf16(2 * S + 1), tt(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new a.Buf16(2 * S + 1), tt(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function dt(d) {
        var z;
        return d && d.state ? (d.total_in = d.total_out = 0, d.data_type = p, (z = d.state).pending = 0, z.pending_out = 0, z.wrap < 0 && (z.wrap = -z.wrap), z.status = z.wrap ? I : O, d.adler = z.wrap === 2 ? 0 : 1, z.last_flush = w, r._tr_init(z), f) : ot(d, v);
      }
      function Dt(d) {
        var z = dt(d);
        return z === f && function(J) {
          J.window_size = 2 * J.w_size, tt(J.head), J.max_lazy_match = i[J.level].max_lazy, J.good_match = i[J.level].good_length, J.nice_match = i[J.level].nice_length, J.max_chain_length = i[J.level].max_chain, J.strstart = 0, J.block_start = 0, J.lookahead = 0, J.insert = 0, J.match_length = J.prev_length = A - 1, J.match_available = 0, J.ins_h = 0;
        }(d.state), z;
      }
      function It(d, z, J, k, C, N) {
        if (!d)
          return v;
        var $ = 1;
        if (z === h && (z = 6), k < 0 ? ($ = 0, k = -k) : 15 < k && ($ = 2, k -= 16), C < 1 || _ < C || J !== y || k < 8 || 15 < k || z < 0 || 9 < z || N < 0 || b < N)
          return ot(d, v);
        k === 8 && (k = 9);
        var U = new ht();
        return (d.state = U).strm = d, U.wrap = $, U.gzhead = null, U.w_bits = k, U.w_size = 1 << U.w_bits, U.w_mask = U.w_size - 1, U.hash_bits = C + 7, U.hash_size = 1 << U.hash_bits, U.hash_mask = U.hash_size - 1, U.hash_shift = ~~((U.hash_bits + A - 1) / A), U.window = new a.Buf8(2 * U.w_size), U.head = new a.Buf16(U.hash_size), U.prev = new a.Buf16(U.w_size), U.lit_bufsize = 1 << C + 6, U.pending_buf_size = 4 * U.lit_bufsize, U.pending_buf = new a.Buf8(U.pending_buf_size), U.d_buf = 1 * U.lit_bufsize, U.l_buf = 3 * U.lit_bufsize, U.level = z, U.strategy = N, U.method = J, Dt(d);
      }
      i = [new rt(0, 0, 0, 0, function(d, z) {
        var J = 65535;
        for (J > d.pending_buf_size - 5 && (J = d.pending_buf_size - 5); ; ) {
          if (d.lookahead <= 1) {
            if (ct(d), d.lookahead === 0 && z === w)
              return l;
            if (d.lookahead === 0)
              break;
          }
          d.strstart += d.lookahead, d.lookahead = 0;
          var k = d.block_start + J;
          if ((d.strstart === 0 || d.strstart >= k) && (d.lookahead = d.strstart - k, d.strstart = k, R(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - V && (R(d, !1), d.strm.avail_out === 0))
            return l;
        }
        return d.insert = 0, z === g ? (R(d, !0), d.strm.avail_out === 0 ? et : L) : (d.strstart > d.block_start && (R(d, !1), d.strm.avail_out), l);
      }), new rt(4, 4, 8, 4, wt), new rt(4, 5, 16, 8, wt), new rt(4, 6, 32, 32, wt), new rt(4, 4, 16, 16, nt), new rt(8, 16, 32, 32, nt), new rt(8, 16, 128, 128, nt), new rt(8, 32, 128, 256, nt), new rt(32, 128, 258, 1024, nt), new rt(32, 258, 258, 4096, nt)], n.deflateInit = function(d, z) {
        return It(d, z, y, 15, 8, 0);
      }, n.deflateInit2 = It, n.deflateReset = Dt, n.deflateResetKeep = dt, n.deflateSetHeader = function(d, z) {
        return d && d.state ? d.state.wrap !== 2 ? v : (d.state.gzhead = z, f) : v;
      }, n.deflate = function(d, z) {
        var J, k, C, N;
        if (!d || !d.state || 5 < z || z < 0)
          return d ? ot(d, v) : v;
        if (k = d.state, !d.output || !d.input && d.avail_in !== 0 || k.status === 666 && z !== g)
          return ot(d, d.avail_out === 0 ? -5 : v);
        if (k.strm = d, J = k.last_flush, k.last_flush = z, k.status === I)
          if (k.wrap === 2)
            d.adler = 0, Q(k, 31), Q(k, 139), Q(k, 8), k.gzhead ? (Q(k, (k.gzhead.text ? 1 : 0) + (k.gzhead.hcrc ? 2 : 0) + (k.gzhead.extra ? 4 : 0) + (k.gzhead.name ? 8 : 0) + (k.gzhead.comment ? 16 : 0)), Q(k, 255 & k.gzhead.time), Q(k, k.gzhead.time >> 8 & 255), Q(k, k.gzhead.time >> 16 & 255), Q(k, k.gzhead.time >> 24 & 255), Q(k, k.level === 9 ? 2 : 2 <= k.strategy || k.level < 2 ? 4 : 0), Q(k, 255 & k.gzhead.os), k.gzhead.extra && k.gzhead.extra.length && (Q(k, 255 & k.gzhead.extra.length), Q(k, k.gzhead.extra.length >> 8 & 255)), k.gzhead.hcrc && (d.adler = m(d.adler, k.pending_buf, k.pending, 0)), k.gzindex = 0, k.status = 69) : (Q(k, 0), Q(k, 0), Q(k, 0), Q(k, 0), Q(k, 0), Q(k, k.level === 9 ? 2 : 2 <= k.strategy || k.level < 2 ? 4 : 0), Q(k, 3), k.status = O);
          else {
            var $ = y + (k.w_bits - 8 << 4) << 8;
            $ |= (2 <= k.strategy || k.level < 2 ? 0 : k.level < 6 ? 1 : k.level === 6 ? 2 : 3) << 6, k.strstart !== 0 && ($ |= 32), $ += 31 - $ % 31, k.status = O, Z(k, $), k.strstart !== 0 && (Z(k, d.adler >>> 16), Z(k, 65535 & d.adler)), d.adler = 1;
          }
        if (k.status === 69)
          if (k.gzhead.extra) {
            for (C = k.pending; k.gzindex < (65535 & k.gzhead.extra.length) && (k.pending !== k.pending_buf_size || (k.gzhead.hcrc && k.pending > C && (d.adler = m(d.adler, k.pending_buf, k.pending - C, C)), j(d), C = k.pending, k.pending !== k.pending_buf_size)); )
              Q(k, 255 & k.gzhead.extra[k.gzindex]), k.gzindex++;
            k.gzhead.hcrc && k.pending > C && (d.adler = m(d.adler, k.pending_buf, k.pending - C, C)), k.gzindex === k.gzhead.extra.length && (k.gzindex = 0, k.status = 73);
          } else
            k.status = 73;
        if (k.status === 73)
          if (k.gzhead.name) {
            C = k.pending;
            do {
              if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > C && (d.adler = m(d.adler, k.pending_buf, k.pending - C, C)), j(d), C = k.pending, k.pending === k.pending_buf_size)) {
                N = 1;
                break;
              }
              N = k.gzindex < k.gzhead.name.length ? 255 & k.gzhead.name.charCodeAt(k.gzindex++) : 0, Q(k, N);
            } while (N !== 0);
            k.gzhead.hcrc && k.pending > C && (d.adler = m(d.adler, k.pending_buf, k.pending - C, C)), N === 0 && (k.gzindex = 0, k.status = 91);
          } else
            k.status = 91;
        if (k.status === 91)
          if (k.gzhead.comment) {
            C = k.pending;
            do {
              if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > C && (d.adler = m(d.adler, k.pending_buf, k.pending - C, C)), j(d), C = k.pending, k.pending === k.pending_buf_size)) {
                N = 1;
                break;
              }
              N = k.gzindex < k.gzhead.comment.length ? 255 & k.gzhead.comment.charCodeAt(k.gzindex++) : 0, Q(k, N);
            } while (N !== 0);
            k.gzhead.hcrc && k.pending > C && (d.adler = m(d.adler, k.pending_buf, k.pending - C, C)), N === 0 && (k.status = 103);
          } else
            k.status = 103;
        if (k.status === 103 && (k.gzhead.hcrc ? (k.pending + 2 > k.pending_buf_size && j(d), k.pending + 2 <= k.pending_buf_size && (Q(k, 255 & d.adler), Q(k, d.adler >> 8 & 255), d.adler = 0, k.status = O)) : k.status = O), k.pending !== 0) {
          if (j(d), d.avail_out === 0)
            return k.last_flush = -1, f;
        } else if (d.avail_in === 0 && K(z) <= K(J) && z !== g)
          return ot(d, -5);
        if (k.status === 666 && d.avail_in !== 0)
          return ot(d, -5);
        if (d.avail_in !== 0 || k.lookahead !== 0 || z !== w && k.status !== 666) {
          var U = k.strategy === 2 ? function(E, B) {
            for (var W; ; ) {
              if (E.lookahead === 0 && (ct(E), E.lookahead === 0)) {
                if (B === w)
                  return l;
                break;
              }
              if (E.match_length = 0, W = r._tr_tally(E, 0, E.window[E.strstart]), E.lookahead--, E.strstart++, W && (R(E, !1), E.strm.avail_out === 0))
                return l;
            }
            return E.insert = 0, B === g ? (R(E, !0), E.strm.avail_out === 0 ? et : L) : E.last_lit && (R(E, !1), E.strm.avail_out === 0) ? l : P;
          }(k, z) : k.strategy === 3 ? function(E, B) {
            for (var W, q, Y, st, it = E.window; ; ) {
              if (E.lookahead <= M) {
                if (ct(E), E.lookahead <= M && B === w)
                  return l;
                if (E.lookahead === 0)
                  break;
              }
              if (E.match_length = 0, E.lookahead >= A && 0 < E.strstart && (q = it[Y = E.strstart - 1]) === it[++Y] && q === it[++Y] && q === it[++Y]) {
                st = E.strstart + M;
                do
                  ;
                while (q === it[++Y] && q === it[++Y] && q === it[++Y] && q === it[++Y] && q === it[++Y] && q === it[++Y] && q === it[++Y] && q === it[++Y] && Y < st);
                E.match_length = M - (st - Y), E.match_length > E.lookahead && (E.match_length = E.lookahead);
              }
              if (E.match_length >= A ? (W = r._tr_tally(E, 1, E.match_length - A), E.lookahead -= E.match_length, E.strstart += E.match_length, E.match_length = 0) : (W = r._tr_tally(E, 0, E.window[E.strstart]), E.lookahead--, E.strstart++), W && (R(E, !1), E.strm.avail_out === 0))
                return l;
            }
            return E.insert = 0, B === g ? (R(E, !0), E.strm.avail_out === 0 ? et : L) : E.last_lit && (R(E, !1), E.strm.avail_out === 0) ? l : P;
          }(k, z) : i[k.level].func(k, z);
          if (U !== et && U !== L || (k.status = 666), U === l || U === et)
            return d.avail_out === 0 && (k.last_flush = -1), f;
          if (U === P && (z === 1 ? r._tr_align(k) : z !== 5 && (r._tr_stored_block(k, 0, 0, !1), z === 3 && (tt(k.head), k.lookahead === 0 && (k.strstart = 0, k.block_start = 0, k.insert = 0))), j(d), d.avail_out === 0))
            return k.last_flush = -1, f;
        }
        return z !== g ? f : k.wrap <= 0 ? 1 : (k.wrap === 2 ? (Q(k, 255 & d.adler), Q(k, d.adler >> 8 & 255), Q(k, d.adler >> 16 & 255), Q(k, d.adler >> 24 & 255), Q(k, 255 & d.total_in), Q(k, d.total_in >> 8 & 255), Q(k, d.total_in >> 16 & 255), Q(k, d.total_in >> 24 & 255)) : (Z(k, d.adler >>> 16), Z(k, 65535 & d.adler)), j(d), 0 < k.wrap && (k.wrap = -k.wrap), k.pending !== 0 ? f : 1);
      }, n.deflateEnd = function(d) {
        var z;
        return d && d.state ? (z = d.state.status) !== I && z !== 69 && z !== 73 && z !== 91 && z !== 103 && z !== O && z !== 666 ? ot(d, v) : (d.state = null, z === O ? ot(d, -3) : f) : v;
      }, n.deflateSetDictionary = function(d, z) {
        var J, k, C, N, $, U, E, B, W = z.length;
        if (!d || !d.state || (N = (J = d.state).wrap) === 2 || N === 1 && J.status !== I || J.lookahead)
          return v;
        for (N === 1 && (d.adler = c(d.adler, z, W, 0)), J.wrap = 0, W >= J.w_size && (N === 0 && (tt(J.head), J.strstart = 0, J.block_start = 0, J.insert = 0), B = new a.Buf8(J.w_size), a.arraySet(B, z, W - J.w_size, J.w_size, 0), z = B, W = J.w_size), $ = d.avail_in, U = d.next_in, E = d.input, d.avail_in = W, d.next_in = 0, d.input = z, ct(J); J.lookahead >= A; ) {
          for (k = J.strstart, C = J.lookahead - (A - 1); J.ins_h = (J.ins_h << J.hash_shift ^ J.window[k + A - 1]) & J.hash_mask, J.prev[k & J.w_mask] = J.head[J.ins_h], J.head[J.ins_h] = k, k++, --C; )
            ;
          J.strstart = k, J.lookahead = A - 1, ct(J);
        }
        return J.strstart += J.lookahead, J.block_start = J.strstart, J.insert = J.lookahead, J.lookahead = 0, J.match_length = J.prev_length = A - 1, J.match_available = 0, d.next_in = U, d.input = E, d.avail_in = $, J.wrap = N, f;
      }, n.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(e, o, n) {
      o.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(e, o, n) {
      o.exports = function(i, a) {
        var r, c, m, u, w, g, f, v, h, b, p, y, _, S, D, T, x, F, A, M, V, I, O, l, P;
        r = i.state, c = i.next_in, l = i.input, m = c + (i.avail_in - 5), u = i.next_out, P = i.output, w = u - (a - i.avail_out), g = u + (i.avail_out - 257), f = r.dmax, v = r.wsize, h = r.whave, b = r.wnext, p = r.window, y = r.hold, _ = r.bits, S = r.lencode, D = r.distcode, T = (1 << r.lenbits) - 1, x = (1 << r.distbits) - 1;
        t:
          do {
            _ < 15 && (y += l[c++] << _, _ += 8, y += l[c++] << _, _ += 8), F = S[y & T];
            e:
              for (; ; ) {
                if (y >>>= A = F >>> 24, _ -= A, (A = F >>> 16 & 255) === 0)
                  P[u++] = 65535 & F;
                else {
                  if (!(16 & A)) {
                    if (!(64 & A)) {
                      F = S[(65535 & F) + (y & (1 << A) - 1)];
                      continue e;
                    }
                    if (32 & A) {
                      r.mode = 12;
                      break t;
                    }
                    i.msg = "invalid literal/length code", r.mode = 30;
                    break t;
                  }
                  M = 65535 & F, (A &= 15) && (_ < A && (y += l[c++] << _, _ += 8), M += y & (1 << A) - 1, y >>>= A, _ -= A), _ < 15 && (y += l[c++] << _, _ += 8, y += l[c++] << _, _ += 8), F = D[y & x];
                  o:
                    for (; ; ) {
                      if (y >>>= A = F >>> 24, _ -= A, !(16 & (A = F >>> 16 & 255))) {
                        if (!(64 & A)) {
                          F = D[(65535 & F) + (y & (1 << A) - 1)];
                          continue o;
                        }
                        i.msg = "invalid distance code", r.mode = 30;
                        break t;
                      }
                      if (V = 65535 & F, _ < (A &= 15) && (y += l[c++] << _, (_ += 8) < A && (y += l[c++] << _, _ += 8)), f < (V += y & (1 << A) - 1)) {
                        i.msg = "invalid distance too far back", r.mode = 30;
                        break t;
                      }
                      if (y >>>= A, _ -= A, (A = u - w) < V) {
                        if (h < (A = V - A) && r.sane) {
                          i.msg = "invalid distance too far back", r.mode = 30;
                          break t;
                        }
                        if (O = p, (I = 0) === b) {
                          if (I += v - A, A < M) {
                            for (M -= A; P[u++] = p[I++], --A; )
                              ;
                            I = u - V, O = P;
                          }
                        } else if (b < A) {
                          if (I += v + b - A, (A -= b) < M) {
                            for (M -= A; P[u++] = p[I++], --A; )
                              ;
                            if (I = 0, b < M) {
                              for (M -= A = b; P[u++] = p[I++], --A; )
                                ;
                              I = u - V, O = P;
                            }
                          }
                        } else if (I += b - A, A < M) {
                          for (M -= A; P[u++] = p[I++], --A; )
                            ;
                          I = u - V, O = P;
                        }
                        for (; 2 < M; )
                          P[u++] = O[I++], P[u++] = O[I++], P[u++] = O[I++], M -= 3;
                        M && (P[u++] = O[I++], 1 < M && (P[u++] = O[I++]));
                      } else {
                        for (I = u - V; P[u++] = P[I++], P[u++] = P[I++], P[u++] = P[I++], 2 < (M -= 3); )
                          ;
                        M && (P[u++] = P[I++], 1 < M && (P[u++] = P[I++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (c < m && u < g);
        c -= M = _ >> 3, y &= (1 << (_ -= M << 3)) - 1, i.next_in = c, i.next_out = u, i.avail_in = c < m ? m - c + 5 : 5 - (c - m), i.avail_out = u < g ? g - u + 257 : 257 - (u - g), r.hold = y, r.bits = _;
      };
    }, {}], 49: [function(e, o, n) {
      var i = e("../utils/common"), a = e("./adler32"), r = e("./crc32"), c = e("./inffast"), m = e("./inftrees"), u = 1, w = 2, g = 0, f = -2, v = 1, h = 852, b = 592;
      function p(I) {
        return (I >>> 24 & 255) + (I >>> 8 & 65280) + ((65280 & I) << 8) + ((255 & I) << 24);
      }
      function y() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new i.Buf16(320), this.work = new i.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function _(I) {
        var O;
        return I && I.state ? (O = I.state, I.total_in = I.total_out = O.total = 0, I.msg = "", O.wrap && (I.adler = 1 & O.wrap), O.mode = v, O.last = 0, O.havedict = 0, O.dmax = 32768, O.head = null, O.hold = 0, O.bits = 0, O.lencode = O.lendyn = new i.Buf32(h), O.distcode = O.distdyn = new i.Buf32(b), O.sane = 1, O.back = -1, g) : f;
      }
      function S(I) {
        var O;
        return I && I.state ? ((O = I.state).wsize = 0, O.whave = 0, O.wnext = 0, _(I)) : f;
      }
      function D(I, O) {
        var l, P;
        return I && I.state ? (P = I.state, O < 0 ? (l = 0, O = -O) : (l = 1 + (O >> 4), O < 48 && (O &= 15)), O && (O < 8 || 15 < O) ? f : (P.window !== null && P.wbits !== O && (P.window = null), P.wrap = l, P.wbits = O, S(I))) : f;
      }
      function T(I, O) {
        var l, P;
        return I ? (P = new y(), (I.state = P).window = null, (l = D(I, O)) !== g && (I.state = null), l) : f;
      }
      var x, F, A = !0;
      function M(I) {
        if (A) {
          var O;
          for (x = new i.Buf32(512), F = new i.Buf32(32), O = 0; O < 144; )
            I.lens[O++] = 8;
          for (; O < 256; )
            I.lens[O++] = 9;
          for (; O < 280; )
            I.lens[O++] = 7;
          for (; O < 288; )
            I.lens[O++] = 8;
          for (m(u, I.lens, 0, 288, x, 0, I.work, { bits: 9 }), O = 0; O < 32; )
            I.lens[O++] = 5;
          m(w, I.lens, 0, 32, F, 0, I.work, { bits: 5 }), A = !1;
        }
        I.lencode = x, I.lenbits = 9, I.distcode = F, I.distbits = 5;
      }
      function V(I, O, l, P) {
        var et, L = I.state;
        return L.window === null && (L.wsize = 1 << L.wbits, L.wnext = 0, L.whave = 0, L.window = new i.Buf8(L.wsize)), P >= L.wsize ? (i.arraySet(L.window, O, l - L.wsize, L.wsize, 0), L.wnext = 0, L.whave = L.wsize) : (P < (et = L.wsize - L.wnext) && (et = P), i.arraySet(L.window, O, l - P, et, L.wnext), (P -= et) ? (i.arraySet(L.window, O, l - P, P, 0), L.wnext = P, L.whave = L.wsize) : (L.wnext += et, L.wnext === L.wsize && (L.wnext = 0), L.whave < L.wsize && (L.whave += et))), 0;
      }
      n.inflateReset = S, n.inflateReset2 = D, n.inflateResetKeep = _, n.inflateInit = function(I) {
        return T(I, 15);
      }, n.inflateInit2 = T, n.inflate = function(I, O) {
        var l, P, et, L, ot, K, tt, j, R, Q, Z, H, ct, wt, nt, rt, ht, dt, Dt, It, d, z, J, k, C = 0, N = new i.Buf8(4), $ = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!I || !I.state || !I.output || !I.input && I.avail_in !== 0)
          return f;
        (l = I.state).mode === 12 && (l.mode = 13), ot = I.next_out, et = I.output, tt = I.avail_out, L = I.next_in, P = I.input, K = I.avail_in, j = l.hold, R = l.bits, Q = K, Z = tt, z = g;
        t:
          for (; ; )
            switch (l.mode) {
              case v:
                if (l.wrap === 0) {
                  l.mode = 13;
                  break;
                }
                for (; R < 16; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                if (2 & l.wrap && j === 35615) {
                  N[l.check = 0] = 255 & j, N[1] = j >>> 8 & 255, l.check = r(l.check, N, 2, 0), R = j = 0, l.mode = 2;
                  break;
                }
                if (l.flags = 0, l.head && (l.head.done = !1), !(1 & l.wrap) || (((255 & j) << 8) + (j >> 8)) % 31) {
                  I.msg = "incorrect header check", l.mode = 30;
                  break;
                }
                if ((15 & j) != 8) {
                  I.msg = "unknown compression method", l.mode = 30;
                  break;
                }
                if (R -= 4, d = 8 + (15 & (j >>>= 4)), l.wbits === 0)
                  l.wbits = d;
                else if (d > l.wbits) {
                  I.msg = "invalid window size", l.mode = 30;
                  break;
                }
                l.dmax = 1 << d, I.adler = l.check = 1, l.mode = 512 & j ? 10 : 12, R = j = 0;
                break;
              case 2:
                for (; R < 16; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                if (l.flags = j, (255 & l.flags) != 8) {
                  I.msg = "unknown compression method", l.mode = 30;
                  break;
                }
                if (57344 & l.flags) {
                  I.msg = "unknown header flags set", l.mode = 30;
                  break;
                }
                l.head && (l.head.text = j >> 8 & 1), 512 & l.flags && (N[0] = 255 & j, N[1] = j >>> 8 & 255, l.check = r(l.check, N, 2, 0)), R = j = 0, l.mode = 3;
              case 3:
                for (; R < 32; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                l.head && (l.head.time = j), 512 & l.flags && (N[0] = 255 & j, N[1] = j >>> 8 & 255, N[2] = j >>> 16 & 255, N[3] = j >>> 24 & 255, l.check = r(l.check, N, 4, 0)), R = j = 0, l.mode = 4;
              case 4:
                for (; R < 16; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                l.head && (l.head.xflags = 255 & j, l.head.os = j >> 8), 512 & l.flags && (N[0] = 255 & j, N[1] = j >>> 8 & 255, l.check = r(l.check, N, 2, 0)), R = j = 0, l.mode = 5;
              case 5:
                if (1024 & l.flags) {
                  for (; R < 16; ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  l.length = j, l.head && (l.head.extra_len = j), 512 & l.flags && (N[0] = 255 & j, N[1] = j >>> 8 & 255, l.check = r(l.check, N, 2, 0)), R = j = 0;
                } else
                  l.head && (l.head.extra = null);
                l.mode = 6;
              case 6:
                if (1024 & l.flags && (K < (H = l.length) && (H = K), H && (l.head && (d = l.head.extra_len - l.length, l.head.extra || (l.head.extra = new Array(l.head.extra_len)), i.arraySet(l.head.extra, P, L, H, d)), 512 & l.flags && (l.check = r(l.check, P, H, L)), K -= H, L += H, l.length -= H), l.length))
                  break t;
                l.length = 0, l.mode = 7;
              case 7:
                if (2048 & l.flags) {
                  if (K === 0)
                    break t;
                  for (H = 0; d = P[L + H++], l.head && d && l.length < 65536 && (l.head.name += String.fromCharCode(d)), d && H < K; )
                    ;
                  if (512 & l.flags && (l.check = r(l.check, P, H, L)), K -= H, L += H, d)
                    break t;
                } else
                  l.head && (l.head.name = null);
                l.length = 0, l.mode = 8;
              case 8:
                if (4096 & l.flags) {
                  if (K === 0)
                    break t;
                  for (H = 0; d = P[L + H++], l.head && d && l.length < 65536 && (l.head.comment += String.fromCharCode(d)), d && H < K; )
                    ;
                  if (512 & l.flags && (l.check = r(l.check, P, H, L)), K -= H, L += H, d)
                    break t;
                } else
                  l.head && (l.head.comment = null);
                l.mode = 9;
              case 9:
                if (512 & l.flags) {
                  for (; R < 16; ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  if (j !== (65535 & l.check)) {
                    I.msg = "header crc mismatch", l.mode = 30;
                    break;
                  }
                  R = j = 0;
                }
                l.head && (l.head.hcrc = l.flags >> 9 & 1, l.head.done = !0), I.adler = l.check = 0, l.mode = 12;
                break;
              case 10:
                for (; R < 32; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                I.adler = l.check = p(j), R = j = 0, l.mode = 11;
              case 11:
                if (l.havedict === 0)
                  return I.next_out = ot, I.avail_out = tt, I.next_in = L, I.avail_in = K, l.hold = j, l.bits = R, 2;
                I.adler = l.check = 1, l.mode = 12;
              case 12:
                if (O === 5 || O === 6)
                  break t;
              case 13:
                if (l.last) {
                  j >>>= 7 & R, R -= 7 & R, l.mode = 27;
                  break;
                }
                for (; R < 3; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                switch (l.last = 1 & j, R -= 1, 3 & (j >>>= 1)) {
                  case 0:
                    l.mode = 14;
                    break;
                  case 1:
                    if (M(l), l.mode = 20, O !== 6)
                      break;
                    j >>>= 2, R -= 2;
                    break t;
                  case 2:
                    l.mode = 17;
                    break;
                  case 3:
                    I.msg = "invalid block type", l.mode = 30;
                }
                j >>>= 2, R -= 2;
                break;
              case 14:
                for (j >>>= 7 & R, R -= 7 & R; R < 32; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                if ((65535 & j) != (j >>> 16 ^ 65535)) {
                  I.msg = "invalid stored block lengths", l.mode = 30;
                  break;
                }
                if (l.length = 65535 & j, R = j = 0, l.mode = 15, O === 6)
                  break t;
              case 15:
                l.mode = 16;
              case 16:
                if (H = l.length) {
                  if (K < H && (H = K), tt < H && (H = tt), H === 0)
                    break t;
                  i.arraySet(et, P, L, H, ot), K -= H, L += H, tt -= H, ot += H, l.length -= H;
                  break;
                }
                l.mode = 12;
                break;
              case 17:
                for (; R < 14; ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                if (l.nlen = 257 + (31 & j), j >>>= 5, R -= 5, l.ndist = 1 + (31 & j), j >>>= 5, R -= 5, l.ncode = 4 + (15 & j), j >>>= 4, R -= 4, 286 < l.nlen || 30 < l.ndist) {
                  I.msg = "too many length or distance symbols", l.mode = 30;
                  break;
                }
                l.have = 0, l.mode = 18;
              case 18:
                for (; l.have < l.ncode; ) {
                  for (; R < 3; ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  l.lens[$[l.have++]] = 7 & j, j >>>= 3, R -= 3;
                }
                for (; l.have < 19; )
                  l.lens[$[l.have++]] = 0;
                if (l.lencode = l.lendyn, l.lenbits = 7, J = { bits: l.lenbits }, z = m(0, l.lens, 0, 19, l.lencode, 0, l.work, J), l.lenbits = J.bits, z) {
                  I.msg = "invalid code lengths set", l.mode = 30;
                  break;
                }
                l.have = 0, l.mode = 19;
              case 19:
                for (; l.have < l.nlen + l.ndist; ) {
                  for (; rt = (C = l.lencode[j & (1 << l.lenbits) - 1]) >>> 16 & 255, ht = 65535 & C, !((nt = C >>> 24) <= R); ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  if (ht < 16)
                    j >>>= nt, R -= nt, l.lens[l.have++] = ht;
                  else {
                    if (ht === 16) {
                      for (k = nt + 2; R < k; ) {
                        if (K === 0)
                          break t;
                        K--, j += P[L++] << R, R += 8;
                      }
                      if (j >>>= nt, R -= nt, l.have === 0) {
                        I.msg = "invalid bit length repeat", l.mode = 30;
                        break;
                      }
                      d = l.lens[l.have - 1], H = 3 + (3 & j), j >>>= 2, R -= 2;
                    } else if (ht === 17) {
                      for (k = nt + 3; R < k; ) {
                        if (K === 0)
                          break t;
                        K--, j += P[L++] << R, R += 8;
                      }
                      R -= nt, d = 0, H = 3 + (7 & (j >>>= nt)), j >>>= 3, R -= 3;
                    } else {
                      for (k = nt + 7; R < k; ) {
                        if (K === 0)
                          break t;
                        K--, j += P[L++] << R, R += 8;
                      }
                      R -= nt, d = 0, H = 11 + (127 & (j >>>= nt)), j >>>= 7, R -= 7;
                    }
                    if (l.have + H > l.nlen + l.ndist) {
                      I.msg = "invalid bit length repeat", l.mode = 30;
                      break;
                    }
                    for (; H--; )
                      l.lens[l.have++] = d;
                  }
                }
                if (l.mode === 30)
                  break;
                if (l.lens[256] === 0) {
                  I.msg = "invalid code -- missing end-of-block", l.mode = 30;
                  break;
                }
                if (l.lenbits = 9, J = { bits: l.lenbits }, z = m(u, l.lens, 0, l.nlen, l.lencode, 0, l.work, J), l.lenbits = J.bits, z) {
                  I.msg = "invalid literal/lengths set", l.mode = 30;
                  break;
                }
                if (l.distbits = 6, l.distcode = l.distdyn, J = { bits: l.distbits }, z = m(w, l.lens, l.nlen, l.ndist, l.distcode, 0, l.work, J), l.distbits = J.bits, z) {
                  I.msg = "invalid distances set", l.mode = 30;
                  break;
                }
                if (l.mode = 20, O === 6)
                  break t;
              case 20:
                l.mode = 21;
              case 21:
                if (6 <= K && 258 <= tt) {
                  I.next_out = ot, I.avail_out = tt, I.next_in = L, I.avail_in = K, l.hold = j, l.bits = R, c(I, Z), ot = I.next_out, et = I.output, tt = I.avail_out, L = I.next_in, P = I.input, K = I.avail_in, j = l.hold, R = l.bits, l.mode === 12 && (l.back = -1);
                  break;
                }
                for (l.back = 0; rt = (C = l.lencode[j & (1 << l.lenbits) - 1]) >>> 16 & 255, ht = 65535 & C, !((nt = C >>> 24) <= R); ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                if (rt && !(240 & rt)) {
                  for (dt = nt, Dt = rt, It = ht; rt = (C = l.lencode[It + ((j & (1 << dt + Dt) - 1) >> dt)]) >>> 16 & 255, ht = 65535 & C, !(dt + (nt = C >>> 24) <= R); ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  j >>>= dt, R -= dt, l.back += dt;
                }
                if (j >>>= nt, R -= nt, l.back += nt, l.length = ht, rt === 0) {
                  l.mode = 26;
                  break;
                }
                if (32 & rt) {
                  l.back = -1, l.mode = 12;
                  break;
                }
                if (64 & rt) {
                  I.msg = "invalid literal/length code", l.mode = 30;
                  break;
                }
                l.extra = 15 & rt, l.mode = 22;
              case 22:
                if (l.extra) {
                  for (k = l.extra; R < k; ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  l.length += j & (1 << l.extra) - 1, j >>>= l.extra, R -= l.extra, l.back += l.extra;
                }
                l.was = l.length, l.mode = 23;
              case 23:
                for (; rt = (C = l.distcode[j & (1 << l.distbits) - 1]) >>> 16 & 255, ht = 65535 & C, !((nt = C >>> 24) <= R); ) {
                  if (K === 0)
                    break t;
                  K--, j += P[L++] << R, R += 8;
                }
                if (!(240 & rt)) {
                  for (dt = nt, Dt = rt, It = ht; rt = (C = l.distcode[It + ((j & (1 << dt + Dt) - 1) >> dt)]) >>> 16 & 255, ht = 65535 & C, !(dt + (nt = C >>> 24) <= R); ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  j >>>= dt, R -= dt, l.back += dt;
                }
                if (j >>>= nt, R -= nt, l.back += nt, 64 & rt) {
                  I.msg = "invalid distance code", l.mode = 30;
                  break;
                }
                l.offset = ht, l.extra = 15 & rt, l.mode = 24;
              case 24:
                if (l.extra) {
                  for (k = l.extra; R < k; ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  l.offset += j & (1 << l.extra) - 1, j >>>= l.extra, R -= l.extra, l.back += l.extra;
                }
                if (l.offset > l.dmax) {
                  I.msg = "invalid distance too far back", l.mode = 30;
                  break;
                }
                l.mode = 25;
              case 25:
                if (tt === 0)
                  break t;
                if (H = Z - tt, l.offset > H) {
                  if ((H = l.offset - H) > l.whave && l.sane) {
                    I.msg = "invalid distance too far back", l.mode = 30;
                    break;
                  }
                  ct = H > l.wnext ? (H -= l.wnext, l.wsize - H) : l.wnext - H, H > l.length && (H = l.length), wt = l.window;
                } else
                  wt = et, ct = ot - l.offset, H = l.length;
                for (tt < H && (H = tt), tt -= H, l.length -= H; et[ot++] = wt[ct++], --H; )
                  ;
                l.length === 0 && (l.mode = 21);
                break;
              case 26:
                if (tt === 0)
                  break t;
                et[ot++] = l.length, tt--, l.mode = 21;
                break;
              case 27:
                if (l.wrap) {
                  for (; R < 32; ) {
                    if (K === 0)
                      break t;
                    K--, j |= P[L++] << R, R += 8;
                  }
                  if (Z -= tt, I.total_out += Z, l.total += Z, Z && (I.adler = l.check = l.flags ? r(l.check, et, Z, ot - Z) : a(l.check, et, Z, ot - Z)), Z = tt, (l.flags ? j : p(j)) !== l.check) {
                    I.msg = "incorrect data check", l.mode = 30;
                    break;
                  }
                  R = j = 0;
                }
                l.mode = 28;
              case 28:
                if (l.wrap && l.flags) {
                  for (; R < 32; ) {
                    if (K === 0)
                      break t;
                    K--, j += P[L++] << R, R += 8;
                  }
                  if (j !== (4294967295 & l.total)) {
                    I.msg = "incorrect length check", l.mode = 30;
                    break;
                  }
                  R = j = 0;
                }
                l.mode = 29;
              case 29:
                z = 1;
                break t;
              case 30:
                z = -3;
                break t;
              case 31:
                return -4;
              case 32:
              default:
                return f;
            }
        return I.next_out = ot, I.avail_out = tt, I.next_in = L, I.avail_in = K, l.hold = j, l.bits = R, (l.wsize || Z !== I.avail_out && l.mode < 30 && (l.mode < 27 || O !== 4)) && V(I, I.output, I.next_out, Z - I.avail_out) ? (l.mode = 31, -4) : (Q -= I.avail_in, Z -= I.avail_out, I.total_in += Q, I.total_out += Z, l.total += Z, l.wrap && Z && (I.adler = l.check = l.flags ? r(l.check, et, Z, I.next_out - Z) : a(l.check, et, Z, I.next_out - Z)), I.data_type = l.bits + (l.last ? 64 : 0) + (l.mode === 12 ? 128 : 0) + (l.mode === 20 || l.mode === 15 ? 256 : 0), (Q == 0 && Z === 0 || O === 4) && z === g && (z = -5), z);
      }, n.inflateEnd = function(I) {
        if (!I || !I.state)
          return f;
        var O = I.state;
        return O.window && (O.window = null), I.state = null, g;
      }, n.inflateGetHeader = function(I, O) {
        var l;
        return I && I.state && 2 & (l = I.state).wrap ? ((l.head = O).done = !1, g) : f;
      }, n.inflateSetDictionary = function(I, O) {
        var l, P = O.length;
        return I && I.state ? (l = I.state).wrap !== 0 && l.mode !== 11 ? f : l.mode === 11 && a(1, O, P, 0) !== l.check ? -3 : V(I, O, P, P) ? (l.mode = 31, -4) : (l.havedict = 1, g) : f;
      }, n.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(e, o, n) {
      var i = e("../utils/common"), a = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], r = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], c = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], m = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      o.exports = function(u, w, g, f, v, h, b, p) {
        var y, _, S, D, T, x, F, A, M, V = p.bits, I = 0, O = 0, l = 0, P = 0, et = 0, L = 0, ot = 0, K = 0, tt = 0, j = 0, R = null, Q = 0, Z = new i.Buf16(16), H = new i.Buf16(16), ct = null, wt = 0;
        for (I = 0; I <= 15; I++)
          Z[I] = 0;
        for (O = 0; O < f; O++)
          Z[w[g + O]]++;
        for (et = V, P = 15; 1 <= P && Z[P] === 0; P--)
          ;
        if (P < et && (et = P), P === 0)
          return v[h++] = 20971520, v[h++] = 20971520, p.bits = 1, 0;
        for (l = 1; l < P && Z[l] === 0; l++)
          ;
        for (et < l && (et = l), I = K = 1; I <= 15; I++)
          if (K <<= 1, (K -= Z[I]) < 0)
            return -1;
        if (0 < K && (u === 0 || P !== 1))
          return -1;
        for (H[1] = 0, I = 1; I < 15; I++)
          H[I + 1] = H[I] + Z[I];
        for (O = 0; O < f; O++)
          w[g + O] !== 0 && (b[H[w[g + O]]++] = O);
        if (x = u === 0 ? (R = ct = b, 19) : u === 1 ? (R = a, Q -= 257, ct = r, wt -= 257, 256) : (R = c, ct = m, -1), I = l, T = h, ot = O = j = 0, S = -1, D = (tt = 1 << (L = et)) - 1, u === 1 && 852 < tt || u === 2 && 592 < tt)
          return 1;
        for (; ; ) {
          for (F = I - ot, M = b[O] < x ? (A = 0, b[O]) : b[O] > x ? (A = ct[wt + b[O]], R[Q + b[O]]) : (A = 96, 0), y = 1 << I - ot, l = _ = 1 << L; v[T + (j >> ot) + (_ -= y)] = F << 24 | A << 16 | M | 0, _ !== 0; )
            ;
          for (y = 1 << I - 1; j & y; )
            y >>= 1;
          if (y !== 0 ? (j &= y - 1, j += y) : j = 0, O++, --Z[I] == 0) {
            if (I === P)
              break;
            I = w[g + b[O]];
          }
          if (et < I && (j & D) !== S) {
            for (ot === 0 && (ot = et), T += l, K = 1 << (L = I - ot); L + ot < P && !((K -= Z[L + ot]) <= 0); )
              L++, K <<= 1;
            if (tt += 1 << L, u === 1 && 852 < tt || u === 2 && 592 < tt)
              return 1;
            v[S = j & D] = et << 24 | L << 16 | T - h | 0;
          }
        }
        return j !== 0 && (v[T + j] = I - ot << 24 | 64 << 16 | 0), p.bits = et, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(e, o, n) {
      o.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(e, o, n) {
      var i = e("../utils/common"), a = 0, r = 1;
      function c(C) {
        for (var N = C.length; 0 <= --N; )
          C[N] = 0;
      }
      var m = 0, u = 29, w = 256, g = w + 1 + u, f = 30, v = 19, h = 2 * g + 1, b = 15, p = 16, y = 7, _ = 256, S = 16, D = 17, T = 18, x = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], F = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], A = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], M = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], V = new Array(2 * (g + 2));
      c(V);
      var I = new Array(2 * f);
      c(I);
      var O = new Array(512);
      c(O);
      var l = new Array(256);
      c(l);
      var P = new Array(u);
      c(P);
      var et, L, ot, K = new Array(f);
      function tt(C, N, $, U, E) {
        this.static_tree = C, this.extra_bits = N, this.extra_base = $, this.elems = U, this.max_length = E, this.has_stree = C && C.length;
      }
      function j(C, N) {
        this.dyn_tree = C, this.max_code = 0, this.stat_desc = N;
      }
      function R(C) {
        return C < 256 ? O[C] : O[256 + (C >>> 7)];
      }
      function Q(C, N) {
        C.pending_buf[C.pending++] = 255 & N, C.pending_buf[C.pending++] = N >>> 8 & 255;
      }
      function Z(C, N, $) {
        C.bi_valid > p - $ ? (C.bi_buf |= N << C.bi_valid & 65535, Q(C, C.bi_buf), C.bi_buf = N >> p - C.bi_valid, C.bi_valid += $ - p) : (C.bi_buf |= N << C.bi_valid & 65535, C.bi_valid += $);
      }
      function H(C, N, $) {
        Z(C, $[2 * N], $[2 * N + 1]);
      }
      function ct(C, N) {
        for (var $ = 0; $ |= 1 & C, C >>>= 1, $ <<= 1, 0 < --N; )
          ;
        return $ >>> 1;
      }
      function wt(C, N, $) {
        var U, E, B = new Array(b + 1), W = 0;
        for (U = 1; U <= b; U++)
          B[U] = W = W + $[U - 1] << 1;
        for (E = 0; E <= N; E++) {
          var q = C[2 * E + 1];
          q !== 0 && (C[2 * E] = ct(B[q]++, q));
        }
      }
      function nt(C) {
        var N;
        for (N = 0; N < g; N++)
          C.dyn_ltree[2 * N] = 0;
        for (N = 0; N < f; N++)
          C.dyn_dtree[2 * N] = 0;
        for (N = 0; N < v; N++)
          C.bl_tree[2 * N] = 0;
        C.dyn_ltree[2 * _] = 1, C.opt_len = C.static_len = 0, C.last_lit = C.matches = 0;
      }
      function rt(C) {
        8 < C.bi_valid ? Q(C, C.bi_buf) : 0 < C.bi_valid && (C.pending_buf[C.pending++] = C.bi_buf), C.bi_buf = 0, C.bi_valid = 0;
      }
      function ht(C, N, $, U) {
        var E = 2 * N, B = 2 * $;
        return C[E] < C[B] || C[E] === C[B] && U[N] <= U[$];
      }
      function dt(C, N, $) {
        for (var U = C.heap[$], E = $ << 1; E <= C.heap_len && (E < C.heap_len && ht(N, C.heap[E + 1], C.heap[E], C.depth) && E++, !ht(N, U, C.heap[E], C.depth)); )
          C.heap[$] = C.heap[E], $ = E, E <<= 1;
        C.heap[$] = U;
      }
      function Dt(C, N, $) {
        var U, E, B, W, q = 0;
        if (C.last_lit !== 0)
          for (; U = C.pending_buf[C.d_buf + 2 * q] << 8 | C.pending_buf[C.d_buf + 2 * q + 1], E = C.pending_buf[C.l_buf + q], q++, U === 0 ? H(C, E, N) : (H(C, (B = l[E]) + w + 1, N), (W = x[B]) !== 0 && Z(C, E -= P[B], W), H(C, B = R(--U), $), (W = F[B]) !== 0 && Z(C, U -= K[B], W)), q < C.last_lit; )
            ;
        H(C, _, N);
      }
      function It(C, N) {
        var $, U, E, B = N.dyn_tree, W = N.stat_desc.static_tree, q = N.stat_desc.has_stree, Y = N.stat_desc.elems, st = -1;
        for (C.heap_len = 0, C.heap_max = h, $ = 0; $ < Y; $++)
          B[2 * $] !== 0 ? (C.heap[++C.heap_len] = st = $, C.depth[$] = 0) : B[2 * $ + 1] = 0;
        for (; C.heap_len < 2; )
          B[2 * (E = C.heap[++C.heap_len] = st < 2 ? ++st : 0)] = 1, C.depth[E] = 0, C.opt_len--, q && (C.static_len -= W[2 * E + 1]);
        for (N.max_code = st, $ = C.heap_len >> 1; 1 <= $; $--)
          dt(C, B, $);
        for (E = Y; $ = C.heap[1], C.heap[1] = C.heap[C.heap_len--], dt(C, B, 1), U = C.heap[1], C.heap[--C.heap_max] = $, C.heap[--C.heap_max] = U, B[2 * E] = B[2 * $] + B[2 * U], C.depth[E] = (C.depth[$] >= C.depth[U] ? C.depth[$] : C.depth[U]) + 1, B[2 * $ + 1] = B[2 * U + 1] = E, C.heap[1] = E++, dt(C, B, 1), 2 <= C.heap_len; )
          ;
        C.heap[--C.heap_max] = C.heap[1], function(it, kt) {
          var Jt, St, Ot, ut, Ft, ie, Et = kt.dyn_tree, Fe = kt.max_code, ho = kt.stat_desc.static_tree, fo = kt.stat_desc.has_stree, mo = kt.stat_desc.extra_bits, Ue = kt.stat_desc.extra_base, zt = kt.stat_desc.max_length, Ut = 0;
          for (ut = 0; ut <= b; ut++)
            it.bl_count[ut] = 0;
          for (Et[2 * it.heap[it.heap_max] + 1] = 0, Jt = it.heap_max + 1; Jt < h; Jt++)
            zt < (ut = Et[2 * Et[2 * (St = it.heap[Jt]) + 1] + 1] + 1) && (ut = zt, Ut++), Et[2 * St + 1] = ut, Fe < St || (it.bl_count[ut]++, Ft = 0, Ue <= St && (Ft = mo[St - Ue]), ie = Et[2 * St], it.opt_len += ie * (ut + Ft), fo && (it.static_len += ie * (ho[2 * St + 1] + Ft)));
          if (Ut !== 0) {
            do {
              for (ut = zt - 1; it.bl_count[ut] === 0; )
                ut--;
              it.bl_count[ut]--, it.bl_count[ut + 1] += 2, it.bl_count[zt]--, Ut -= 2;
            } while (0 < Ut);
            for (ut = zt; ut !== 0; ut--)
              for (St = it.bl_count[ut]; St !== 0; )
                Fe < (Ot = it.heap[--Jt]) || (Et[2 * Ot + 1] !== ut && (it.opt_len += (ut - Et[2 * Ot + 1]) * Et[2 * Ot], Et[2 * Ot + 1] = ut), St--);
          }
        }(C, N), wt(B, st, C.bl_count);
      }
      function d(C, N, $) {
        var U, E, B = -1, W = N[1], q = 0, Y = 7, st = 4;
        for (W === 0 && (Y = 138, st = 3), N[2 * ($ + 1) + 1] = 65535, U = 0; U <= $; U++)
          E = W, W = N[2 * (U + 1) + 1], ++q < Y && E === W || (q < st ? C.bl_tree[2 * E] += q : E !== 0 ? (E !== B && C.bl_tree[2 * E]++, C.bl_tree[2 * S]++) : q <= 10 ? C.bl_tree[2 * D]++ : C.bl_tree[2 * T]++, B = E, st = (q = 0) === W ? (Y = 138, 3) : E === W ? (Y = 6, 3) : (Y = 7, 4));
      }
      function z(C, N, $) {
        var U, E, B = -1, W = N[1], q = 0, Y = 7, st = 4;
        for (W === 0 && (Y = 138, st = 3), U = 0; U <= $; U++)
          if (E = W, W = N[2 * (U + 1) + 1], !(++q < Y && E === W)) {
            if (q < st)
              for (; H(C, E, C.bl_tree), --q != 0; )
                ;
            else
              E !== 0 ? (E !== B && (H(C, E, C.bl_tree), q--), H(C, S, C.bl_tree), Z(C, q - 3, 2)) : q <= 10 ? (H(C, D, C.bl_tree), Z(C, q - 3, 3)) : (H(C, T, C.bl_tree), Z(C, q - 11, 7));
            B = E, st = (q = 0) === W ? (Y = 138, 3) : E === W ? (Y = 6, 3) : (Y = 7, 4);
          }
      }
      c(K);
      var J = !1;
      function k(C, N, $, U) {
        Z(C, (m << 1) + (U ? 1 : 0), 3), function(E, B, W, q) {
          rt(E), Q(E, W), Q(E, ~W), i.arraySet(E.pending_buf, E.window, B, W, E.pending), E.pending += W;
        }(C, N, $);
      }
      n._tr_init = function(C) {
        J || (function() {
          var N, $, U, E, B, W = new Array(b + 1);
          for (E = U = 0; E < u - 1; E++)
            for (P[E] = U, N = 0; N < 1 << x[E]; N++)
              l[U++] = E;
          for (l[U - 1] = E, E = B = 0; E < 16; E++)
            for (K[E] = B, N = 0; N < 1 << F[E]; N++)
              O[B++] = E;
          for (B >>= 7; E < f; E++)
            for (K[E] = B << 7, N = 0; N < 1 << F[E] - 7; N++)
              O[256 + B++] = E;
          for ($ = 0; $ <= b; $++)
            W[$] = 0;
          for (N = 0; N <= 143; )
            V[2 * N + 1] = 8, N++, W[8]++;
          for (; N <= 255; )
            V[2 * N + 1] = 9, N++, W[9]++;
          for (; N <= 279; )
            V[2 * N + 1] = 7, N++, W[7]++;
          for (; N <= 287; )
            V[2 * N + 1] = 8, N++, W[8]++;
          for (wt(V, g + 1, W), N = 0; N < f; N++)
            I[2 * N + 1] = 5, I[2 * N] = ct(N, 5);
          et = new tt(V, x, w + 1, g, b), L = new tt(I, F, 0, f, b), ot = new tt(new Array(0), A, 0, v, y);
        }(), J = !0), C.l_desc = new j(C.dyn_ltree, et), C.d_desc = new j(C.dyn_dtree, L), C.bl_desc = new j(C.bl_tree, ot), C.bi_buf = 0, C.bi_valid = 0, nt(C);
      }, n._tr_stored_block = k, n._tr_flush_block = function(C, N, $, U) {
        var E, B, W = 0;
        0 < C.level ? (C.strm.data_type === 2 && (C.strm.data_type = function(q) {
          var Y, st = 4093624447;
          for (Y = 0; Y <= 31; Y++, st >>>= 1)
            if (1 & st && q.dyn_ltree[2 * Y] !== 0)
              return a;
          if (q.dyn_ltree[18] !== 0 || q.dyn_ltree[20] !== 0 || q.dyn_ltree[26] !== 0)
            return r;
          for (Y = 32; Y < w; Y++)
            if (q.dyn_ltree[2 * Y] !== 0)
              return r;
          return a;
        }(C)), It(C, C.l_desc), It(C, C.d_desc), W = function(q) {
          var Y;
          for (d(q, q.dyn_ltree, q.l_desc.max_code), d(q, q.dyn_dtree, q.d_desc.max_code), It(q, q.bl_desc), Y = v - 1; 3 <= Y && q.bl_tree[2 * M[Y] + 1] === 0; Y--)
            ;
          return q.opt_len += 3 * (Y + 1) + 5 + 5 + 4, Y;
        }(C), E = C.opt_len + 3 + 7 >>> 3, (B = C.static_len + 3 + 7 >>> 3) <= E && (E = B)) : E = B = $ + 5, $ + 4 <= E && N !== -1 ? k(C, N, $, U) : C.strategy === 4 || B === E ? (Z(C, 2 + (U ? 1 : 0), 3), Dt(C, V, I)) : (Z(C, 4 + (U ? 1 : 0), 3), function(q, Y, st, it) {
          var kt;
          for (Z(q, Y - 257, 5), Z(q, st - 1, 5), Z(q, it - 4, 4), kt = 0; kt < it; kt++)
            Z(q, q.bl_tree[2 * M[kt] + 1], 3);
          z(q, q.dyn_ltree, Y - 1), z(q, q.dyn_dtree, st - 1);
        }(C, C.l_desc.max_code + 1, C.d_desc.max_code + 1, W + 1), Dt(C, C.dyn_ltree, C.dyn_dtree)), nt(C), U && rt(C);
      }, n._tr_tally = function(C, N, $) {
        return C.pending_buf[C.d_buf + 2 * C.last_lit] = N >>> 8 & 255, C.pending_buf[C.d_buf + 2 * C.last_lit + 1] = 255 & N, C.pending_buf[C.l_buf + C.last_lit] = 255 & $, C.last_lit++, N === 0 ? C.dyn_ltree[2 * $]++ : (C.matches++, N--, C.dyn_ltree[2 * (l[$] + w + 1)]++, C.dyn_dtree[2 * R(N)]++), C.last_lit === C.lit_bufsize - 1;
      }, n._tr_align = function(C) {
        Z(C, 2, 3), H(C, _, V), function(N) {
          N.bi_valid === 16 ? (Q(N, N.bi_buf), N.bi_buf = 0, N.bi_valid = 0) : 8 <= N.bi_valid && (N.pending_buf[N.pending++] = 255 & N.bi_buf, N.bi_buf >>= 8, N.bi_valid -= 8);
        }(C);
      };
    }, { "../utils/common": 41 }], 53: [function(e, o, n) {
      o.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(e, o, n) {
      (function(i) {
        (function(a, r) {
          if (!a.setImmediate) {
            var c, m, u, w, g = 1, f = {}, v = !1, h = a.document, b = Object.getPrototypeOf && Object.getPrototypeOf(a);
            b = b && b.setTimeout ? b : a, c = {}.toString.call(a.process) === "[object process]" ? function(S) {
              _t.process.nextTick(function() {
                y(S);
              });
            } : function() {
              if (a.postMessage && !a.importScripts) {
                var S = !0, D = a.onmessage;
                return a.onmessage = function() {
                  S = !1;
                }, a.postMessage("", "*"), a.onmessage = D, S;
              }
            }() ? (w = "setImmediate$" + Math.random() + "$", a.addEventListener ? a.addEventListener("message", _, !1) : a.attachEvent("onmessage", _), function(S) {
              a.postMessage(w + S, "*");
            }) : a.MessageChannel ? ((u = new MessageChannel()).port1.onmessage = function(S) {
              y(S.data);
            }, function(S) {
              u.port2.postMessage(S);
            }) : h && "onreadystatechange" in h.createElement("script") ? (m = h.documentElement, function(S) {
              var D = h.createElement("script");
              D.onreadystatechange = function() {
                y(S), D.onreadystatechange = null, m.removeChild(D), D = null;
              }, m.appendChild(D);
            }) : function(S) {
              setTimeout(y, 0, S);
            }, b.setImmediate = function(S) {
              typeof S != "function" && (S = new Function("" + S));
              for (var D = new Array(arguments.length - 1), T = 0; T < D.length; T++)
                D[T] = arguments[T + 1];
              var x = { callback: S, args: D };
              return f[g] = x, c(g), g++;
            }, b.clearImmediate = p;
          }
          function p(S) {
            delete f[S];
          }
          function y(S) {
            if (v)
              setTimeout(y, 0, S);
            else {
              var D = f[S];
              if (D) {
                v = !0;
                try {
                  (function(T) {
                    var x = T.callback, F = T.args;
                    switch (F.length) {
                      case 0:
                        x();
                        break;
                      case 1:
                        x(F[0]);
                        break;
                      case 2:
                        x(F[0], F[1]);
                        break;
                      case 3:
                        x(F[0], F[1], F[2]);
                        break;
                      default:
                        x.apply(r, F);
                    }
                  })(D);
                } finally {
                  p(S), v = !1;
                }
              }
            }
          }
          function _(S) {
            S.source === a && typeof S.data == "string" && S.data.indexOf(w) === 0 && y(+S.data.slice(w.length));
          }
        })(typeof self > "u" ? i === void 0 ? this : i : self);
      }).call(this, typeof Mt < "u" ? Mt : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(io);
var ao = io.exports;
function ft(s) {
  const t = $e.AttestationSpecification.encodeDelimited(
    s.proto
  ).finish(), e = X.sha256.create();
  return e.update(X.util.binary.raw.encode(t)), e.digest().toHex();
}
async function mt(s, t, e) {
  await s.post({
    query: Rt(`
      mutation SetJobIdForDataConnectorJob(
        $input: SetJobIdForDataConnectorJobInput!
      ) {
        dataConnectorJob {
          setJobId(input: $input) {
            record {
              id
            }
          }
        }
      }
    `),
    variables: {
      input: { id: t, ...e }
    }
  });
}
async function ro(s, t) {
  await s.post({
    query: Rt(`
      mutation SetDataConnectorJobToFailed($id: String!) {
        dataConnectorJob {
          setJobToFailed(id: $id) {
            record {
              id
            }
          }
        }
      }
    `),
    variables: { id: t }
  });
}
async function Wo(s, t) {
  await s.post({
    query: Rt(`
      mutation SetDataConnectorJobToSuccess($id: String!) {
        dataConnectorJob {
          setJobToSuccess(id: $id) {
            record {
              id
            }
          }
        }
      }
    `),
    variables: { id: t }
  });
}
async function so(s, t) {
  const o = (await s.post({
    query: Rt(`
      query GetDataConnectorJob($id: String!) {
        dataConnectorJob(id: $id) {
          name
          type
          computeJobId
          computeJobNode
          dataRoomId
          driverAttestationHash
        }
      }
    `),
    variables: { id: t }
  })).dataConnectorJob;
  return {
    dataRoomId: o.dataRoomId,
    driverAttestationHash: o.driverAttestationHash,
    jobId: {
      computeNodeId: o.computeJobNode,
      jobId: o.computeJobId
    },
    name: o.name,
    type: o.type
  };
}
async function pt({
  graphqlClient: s,
  config: t,
  payload: e
}) {
  let o;
  switch (e.type) {
    case lt.ExportDataset: {
      const { type: a, ...r } = e;
      o = {
        exportDataset: r
      };
      break;
    }
    case lt.ImportDataset: {
      const { type: a, ...r } = e;
      o = {
        importDataset: r
      };
      break;
    }
    case lt.ExportDcrJobResult: {
      const { type: a, ...r } = e;
      o = {
        exportDcrJobResult: r
      };
      break;
    }
    default:
      throw new Error(`Unknown data connector job type: ${e.type}`);
  }
  return (await s.post({
    query: Rt(`
      mutation CreateDataConnectorJob($input: CreateDataConnectorJobInput!) {
        dataConnectorJob {
          create(input: $input) {
            record {
              id
            }
          }
        }
      }
    `),
    variables: {
      input: {
        config: t,
        payload: o
      }
    }
  })).dataConnectorJob.create.record.id;
}
async function Vo(s) {
  const e = await (await ao.loadAsync(s)).file("datasets.json").async("string");
  try {
    return JSON.parse(e);
  } catch {
    throw new Error(
      "Could not parse the dataset meta information as a JSON object"
    );
  }
}
async function Go({
  dataConnectorJobId: s,
  client: t,
  options: { additionalEnclaveSpecs: e = [] } = {}
}) {
  const {
    jobId: o,
    type: n,
    driverAttestationHash: i
  } = await so(t.graphql, s), r = [
    ...oo.getAll(),
    ...e
  ].find((g) => ft(g) === i);
  if (!r)
    throw new Error(
      `Unable to find the driver spec with attestation specification hash '${i}'`
    );
  const c = /* @__PURE__ */ new Map([["decentriq.driver", r]]), m = await t.createAuthUsingDecentriqPki(c), w = await (await t.createSession(m, c)).getComputationResult(o, { interval: 5 });
  switch (n) {
    case lt.ImportDataset:
      return Vo(w);
    case lt.ExportDataset:
      return w;
    default:
      throw new Error(`Unknown data connector job type: ${n}`);
  }
}
const ii = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  enclaveSpecToHex: ft,
  getDataConnectorJob: so,
  getDataConnectorJobResult: Go,
  registerDataConnectorJob: pt,
  setDataConnectorJobToFailed: ro,
  setDataConnectorJobToSuccess: Wo,
  setJobIdForDataConnectorJob: mt
}, Symbol.toStringTag, { value: "Module" }));
async function co(s, {
  dataLabId: t,
  validationJobId: e,
  statisticsJobId: o,
  jobsDriverAttestationHash: n
}) {
  await s.post({
    query: Rt(`
      mutation SetDataLabJobIds($input: SetDataLabJobIdsInput!) {
        dataLab {
          setJobIds(input: $input) {
            record {
              id
            }
          }
        }
      }
    `),
    variables: {
      input: {
        id: t,
        jobsDriverAttestationHash: n,
        statisticsComputeJobId: o,
        validationComputeJobId: e
      }
    }
  });
}
async function Xo(s, t) {
  if (t.requireEmbeddingsDataset) {
    if (!t.numEmbeddings)
      throw new Error(
        "If embeddings are required, the number of embeddings must be set and non-zero."
      );
  } else
    t.numEmbeddings = 0;
  const e = t.numEmbeddings, o = await s.post({
    query: Rt(`
      mutation CreateDataLab($input: CreateDataLabInput!) {
        dataLab {
          create(input: $input) {
            record {
              id
              highLevelRepresentationAsString
            }
          }
        }
      }
    `),
    variables: {
      input: {
        ...t,
        matchingIdFormat: t.matchingIdFormat,
        matchingIdHashingAlgorithm: t.matchingIdHashingAlgorithm,
        numEmbeddings: e
      }
    }
  }), n = o.dataLab.create.record.highLevelRepresentationAsString, i = o.dataLab.create.record.id;
  return {
    dataLab: JSON.parse(n),
    id: i
  };
}
async function uo(s, t) {
  const o = (await t.post({
    query: Rt(`
      query GetDataLab($id: String!) {
        dataLab(id: $id) {
          highLevelRepresentationAsString
        }
      }
    `),
    variables: {
      id: s
    }
  })).dataLab.highLevelRepresentationAsString;
  return JSON.parse(o);
}
async function Yo(s, t, {
  dataLabId: e,
  includeInsecureEnclaves: o,
  usersDataset: n,
  segmentsDataset: i,
  demographicsDataset: a,
  embeddingsDataset: r
}) {
  const c = t.compiler.dataLab, m = await s.decentriqCaRootCertificate(), u = new TextDecoder().decode(m), w = await s.getEnclaveSpecifications(), g = xo(
    w,
    o
  ), f = (I) => ({
    attestationProtoBase64: X.util.binary.base64.encode(
      $e.AttestationSpecification.encodeDelimited(
        I.proto
      ).finish()
    ),
    id: I.name,
    workerProtocol: I.workerProtocols[0]
  }), v = g.get("decentriq.driver");
  if (v === void 0)
    throw new Error("Driver enclave specification not found");
  const h = f(v), b = g.get(
    "decentriq.python-ml-worker-32-64"
  );
  if (b === void 0)
    throw new Error("Python enclave specification not found");
  const p = f(b), y = await uo(e, s.graphql), _ = c.updateEnclaveSpecifications(y, {
    driverSpec: h,
    pythonSpec: p,
    rootCertificatePem: u
  }), S = c.compile(_), D = go.DataRoom.decodeDelimited(
    S
  );
  D.id = `${D.id}-${Date.now()}`;
  const T = await t.publishDataRoom(D, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_LAB
  }), x = c.getFeatures(y);
  await t.publishDataset(
    T,
    n.manifestHash,
    c.getLeafNodeIdForDataset(xt.Users, x),
    n.key
  ), i && await t.publishDataset(
    T,
    i.manifestHash,
    c.getLeafNodeIdForDataset(xt.Segments, x),
    i.key
  ), a && await t.publishDataset(
    T,
    a.manifestHash,
    c.getLeafNodeIdForDataset(xt.Demographics, x),
    a.key
  ), r && await t.publishDataset(
    T,
    r.manifestHash,
    c.getLeafNodeIdForDataset(xt.Embeddings, x),
    r.key
  );
  const F = [
    c.getReportNodeIdForDataset(xt.Users, x),
    ...i ? [
      c.getReportNodeIdForDataset(
        xt.Segments,
        x
      )
    ] : [],
    ...a ? [
      c.getReportNodeIdForDataset(
        xt.Demographics,
        x
      )
    ] : [],
    ...r ? [
      c.getReportNodeIdForDataset(
        xt.Embeddings,
        x
      )
    ] : []
  ], A = X.util.binary.hex.encode(
    (await t.submitCompute(T, F)).jobId
  ), M = (await t.runComputation(
    T,
    c.getPublisherDataStatisticsNodeId()
  )).jobId, V = t.metaData.driverAttestationSpecificationHash;
  return await co(s.graphql, {
    dataLabId: e,
    jobsDriverAttestationHash: V,
    statisticsJobId: M,
    validationJobId: A
  }), {
    jobsDriverAttestationHash: V,
    statisticsJobId: M,
    validationJobId: A
  };
}
async function Qo(s, t, e, o, n, i) {
  let a;
  try {
    const c = (await s.getComputationStatus(t)).completeComputeNodeIds, m = 1 + (o ? 1 : 0) + (n ? 1 : 0) + (i ? 1 : 0);
    c?.length !== m ? a = {
      status: "PENDING"
    } : a = {
      status: "SUCCESS"
    };
  } catch (c) {
    a = {
      error: c.message,
      status: "ERROR"
    };
  }
  let r;
  try {
    (await s.getComputationStatus(e)).completeComputeNodeIds?.length !== 1 ? r = {
      status: "PENDING"
    } : r = {
      status: "SUCCESS"
    };
  } catch (c) {
    r = {
      error: c.message,
      status: "ERROR"
    };
  }
  return {
    statistics: r,
    validation: a
  };
}
async function tn(s, t, e, o) {
  const n = X.util.binary.hex.decode(t);
  return await s.getJobResults(
    n,
    s.compiler.dataLab.getReportNodeIdForDataset(e, o)
  );
}
async function en(s, t) {
  const e = X.util.binary.hex.decode(t);
  return await s.getJobResults(
    e,
    s.compiler.dataLab.getPublisherDataStatisticsNodeId()
  );
}
const ai = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  checkDataLabJobs: Qo,
  computeDataLabStatistics: Yo,
  createDataLab: Xo,
  getDataLabDatasetValidationReport: tn,
  getDataLabHL: uo,
  getDataLabStatisticsReport: en,
  storeJobIds: co
}, Symbol.toStringTag, { value: "Module" }));
let on;
const nn = typeof TextDecoder < "u" ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
typeof TextDecoder < "u" && nn.decode();
const re = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : { encode: () => {
  throw Error("TextEncoder not available");
} };
re.encodeInto;
typeof FinalizationRegistry > "u" || new FinalizationRegistry((s) => on.__wbg_validate_free(s >>> 0, 1));
let an;
const se = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : { encode: () => {
  throw Error("TextEncoder not available");
} };
se.encodeInto;
const rn = typeof TextDecoder < "u" ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
typeof TextDecoder < "u" && rn.decode();
typeof FinalizationRegistry > "u" || new FinalizationRegistry((s) => an.__wbg_autofix_free(s >>> 0, 1));
async function lo(s) {
  let t;
  for await (const e of s)
    t === void 0 && (t = gt.withSize(e.length)), t.extend(e);
  return t?.view() ?? new Uint8Array(0);
}
async function bt(s, t, e) {
  const o = s.get(t), n = lo(o), a = (await ao.loadAsync(n)).file(e);
  if (a)
    return await a.async("text");
  throw new Error("No such file contained in this archive");
}
async function* vt(s, t) {
  for await (const e of s)
    yield await t(e);
}
function ce(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return e.table.validation ? `${s.id}_validation_report` : `${s.id}_verification`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function de(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Kt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Me(s) {
  const t = /* @__PURE__ */ new Map();
  return Kt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class sn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v0";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Me(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = de(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = de(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(de(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = ce(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v0" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Kt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v0);
        }
      );
      const a = Me(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = ce(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    throw new Error("Fetch job result size is not supported in this version");
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v0: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v0: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v0" in o) {
      Kt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v0);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v0: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Kt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  async validateTableNode(t) {
    throw new Error("Validating table nodes is not supported in this version");
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return ce(e);
  }
}
function ue(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_verification`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function le(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Bt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Le(s) {
  const t = /* @__PURE__ */ new Map();
  return Bt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class cn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v1";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Le(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = le(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = le(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(le(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = ue(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v1" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Bt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v1);
        }
      );
      const a = Le(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = ue(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    throw new Error("Fetch job result size is not supported in this version");
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v1: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v1: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v1" in o) {
      Bt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v1);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v1: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Bt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  async validateTableNode(t) {
    throw new Error("Validating table nodes is not supported in this version");
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return ue(e);
  }
}
function he(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function fe(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function qt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Ke(s) {
  const t = /* @__PURE__ */ new Map();
  return qt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class dn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v2";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Ke(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = fe(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = fe(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(fe(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = he(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v2" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      qt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v2);
        }
      );
      const a = Ke(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = he(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    throw new Error("Fetch job result size is not supported in this version");
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v2: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v2: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v2" in o) {
      qt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v2);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v2: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return qt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return he(e);
  }
}
function me(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function pe(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Ht(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Be(s) {
  const t = /* @__PURE__ */ new Map();
  return Ht(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class un {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v3";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Be(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = pe(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = pe(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(pe(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = me(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v3" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Ht(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v3);
        }
      );
      const a = Be(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = me(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    throw new Error("Fetch job result size is not supported in this version");
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v3: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v3: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v3" in o) {
      Ht(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v3);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v3: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Ht(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return me(e);
  }
}
function we(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function ge(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Zt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function qe(s) {
  const t = /* @__PURE__ */ new Map();
  return Zt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class ln {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v4";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = qe(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = ge(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = ge(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(ge(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = we(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v4" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Zt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v4);
        }
      );
      const a = qe(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = we(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length == Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    throw new Error("Fetch job result size is not supported in this version");
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v4: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v4: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v4" in o) {
      Zt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v4);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v4: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Zt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return we(e);
  }
}
function be(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function ve(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Wt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function He(s) {
  const t = /* @__PURE__ */ new Map();
  return Wt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class hn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v5";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = He(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = ve(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = ve(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(ve(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = be(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v5" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Wt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v5);
        }
      );
      const a = He(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = be(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    throw new Error("Fetch job result size is not supported in this version");
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v5: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v5: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v5" in o) {
      Wt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v5);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v5: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Wt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return be(e);
  }
}
function ye(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function Ce(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Vt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Ze(s) {
  const t = /* @__PURE__ */ new Map();
  return Vt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class fn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v6";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Ze(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = Ce(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = Ce(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(Ce(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = ye(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v6" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Vt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v6);
        }
      );
      const a = Ze(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = ye(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v6: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v6: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v6" in o) {
      Vt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v6);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v6: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Vt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return ye(e);
  }
}
function ke(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function _e(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Gt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function We(s) {
  const t = /* @__PURE__ */ new Map();
  return Gt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class mn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v7";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = We(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = _e(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = _e(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(_e(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = ke(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v7" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Gt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v7);
        }
      );
      const a = We(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = ke(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v7: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v7: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v7" in o) {
      Gt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v7);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v7: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Gt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return ke(e);
  }
}
function Ie(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function De(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Xt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Ve(s) {
  const t = /* @__PURE__ */ new Map();
  return Xt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class pn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v8";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Ve(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = De(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = De(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(De(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = Ie(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v8" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Xt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v8);
        }
      );
      const a = Ve(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = Ie(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v8: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v8: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v8" in o) {
      Xt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v8);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v8: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Xt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return Ie(e);
  }
}
function Se(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    if ("environment" in e) {
      if ("python" in e.environment.kind)
        return `${s.id}_env_report`;
      throw new Error("Unknown environment kind");
    } else
      throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function Ne(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Yt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Ge(s) {
  const t = /* @__PURE__ */ new Map();
  return Yt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class wn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v9";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Ge(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = Ne(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = Ne(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(Ne(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = Se(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v9" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Yt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v9);
        }
      );
      const a = Ge(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = Se(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v9: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v9: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v9" in o) {
      Yt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v9);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v9: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Yt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return Se(e);
  }
}
function Ee(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    if ("environment" in e) {
      if ("python" in e.environment.kind)
        return `${s.id}_env_report`;
      throw new Error("Unknown environment kind");
    } else
      throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function Re(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function Qt(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Xe(s) {
  const t = /* @__PURE__ */ new Map();
  return Qt(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class gn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v10";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Xe(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = Re(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = Re(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(Re(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = Ee(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v10" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      Qt(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v10);
        }
      );
      const a = Xe(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = Ee(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v10: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v10: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v10" in o) {
      Qt(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v10);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v10: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return Qt(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return Ee(e);
  }
}
function xe(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    if ("environment" in e) {
      if ("python" in e.environment.kind)
        return `${s.id}_env_report`;
      throw new Error("Unknown environment kind");
    } else
      throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function je(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function te(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Ye(s) {
  const t = /* @__PURE__ */ new Map();
  return te(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class bn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v11";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Ye(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = je(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = je(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(je(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = xe(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v11" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      te(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v11);
        }
      );
      const a = Ye(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = xe(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v11: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v11: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v11" in o) {
      te(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v11);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v11: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return te(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return xe(e);
  }
}
function Ae(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    if ("environment" in e) {
      if ("python" in e.environment.kind)
        return `${s.id}_env_report`;
      throw new Error("Unknown environment kind");
    } else
      throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function Te(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function ee(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function Qe(s) {
  const t = /* @__PURE__ */ new Map();
  return ee(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class vn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v12";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = Qe(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = Te(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = Te(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(Te(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = Ae(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v12" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      ee(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v12);
        }
      );
      const a = Qe(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = Ae(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v12: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v12: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v12" in o) {
      ee(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v12);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v12: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return ee(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return Ae(e);
  }
}
function Je(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    if ("environment" in e) {
      if ("python" in e.environment.kind)
        return `${s.id}_env_report`;
      throw new Error("Unknown environment kind");
    } else
      throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function Oe(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function oe(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function to(s) {
  const t = /* @__PURE__ */ new Map();
  return oe(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class yn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v13";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = to(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = Oe(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = Oe(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(Oe(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = Je(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v13" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      oe(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v13);
        }
      );
      const a = to(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = Je(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v13: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v13: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v13" in o) {
      oe(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v13);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v13: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return oe(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return Je(e);
  }
}
function ze(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_validation_report`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else if ("computation" in t) {
    const e = t.computation.kind;
    if ("sql" in e)
      return s.id;
    if ("sqlite" in e)
      return `${s.id}_container`;
    if ("scripting" in e)
      return `${s.id}_container`;
    if ("syntheticData" in e)
      return `${s.id}_container`;
    if ("s3Sink" in e)
      return s.id;
    if ("match" in e)
      return `${s.id}_match_filter_node`;
    if ("post" in e)
      return s.id;
    if ("preview" in e)
      return s.id;
    if ("environment" in e) {
      if ("python" in e.environment.kind)
        return `${s.id}_env_report`;
      throw new Error("Unknown environment kind");
    } else
      throw new Error("Unknown computation node kind");
  } else
    throw new Error("Unknown node kind");
}
function Pe(s) {
  const t = s.kind;
  if ("leaf" in t) {
    const e = t.leaf.kind;
    if ("table" in e)
      return `${s.id}_leaf`;
    if ("raw" in e)
      return s.id;
    throw new Error("Unknown leaf node kind");
  } else
    throw "computation" in t ? new Error("Computation nodes cannot be leaf nodes") : new Error("Unknown node kind");
}
function ne(s, t, e) {
  if ("static" in s) {
    const o = s.static;
    return t(o);
  } else if ("interactive" in s) {
    const o = s.interactive;
    return e(o);
  } else
    throw new Error("Unknown data science data room type");
}
function eo(s) {
  const t = /* @__PURE__ */ new Map();
  return ne(
    s,
    (e) => {
      e.nodes.forEach((o) => {
        t.set(o.id, o);
      });
    },
    (e) => {
      e.initialConfiguration.nodes.forEach((o) => {
        t.set(o.id, o);
      }), e.commits.forEach((o) => {
        const n = o.kind;
        if ("addComputation" in n)
          t.set(
            n.addComputation.node.id,
            n.addComputation.node
          );
        else
          throw new Error("Unknown commit kind");
      });
    }
  ), t;
}
class Cn {
  dataScienceDataRoom;
  dataRoomId;
  dataScienceDataRoomVersion = "v14";
  session;
  configurationNodesCache;
  constructor(t, e, o) {
    this.dataRoomId = t, this.dataScienceDataRoom = e, this.session = o, this.configurationNodesCache = eo(
      this.dataScienceDataRoom
    );
  }
  async publishDataset(t, e, o) {
    const n = this.configurationNodesCache.get(e);
    if (!n)
      throw new Error(`Node ${e} not found`);
    const i = Pe(n);
    await this.session.publishDataset(
      this.dataRoomId,
      t,
      i,
      o
    );
  }
  async unpublishDataset(t) {
    const e = this.configurationNodesCache.get(t);
    if (!e)
      throw new Error(`Node ${t} not found`);
    const o = Pe(e);
    await this.session.removePublishedDataset(
      this.dataRoomId,
      o
    );
  }
  async retrievePublishedDatasets() {
    const t = (await this.session.retrievePublishedDatasets(this.dataRoomId)).publishedDatasets || [], e = /* @__PURE__ */ new Map();
    this.configurationNodesCache.forEach((o) => {
      "leaf" in o.kind && e.set(Pe(o), o.id);
    });
    for (const o of t)
      o.leafId = e.get(o.leafId);
    return t;
  }
  async createJob(t, e = {}) {
    const o = t.reduce(
      (a, r) => {
        const c = this.configurationNodesCache.get(r);
        if (!c)
          throw new Error(`Node ${r} not found`);
        return a[r] = ze(c), a;
      },
      {}
    ), n = await this.session.submitCompute(
      this.dataRoomId,
      Object.values(o),
      e
    );
    if (!n.jobId)
      throw new Error(`Job ID ${n.jobId} not found`);
    const i = X.util.binary.hex.encode(n.jobId);
    return {
      computeNodeIds: o,
      jobId: i
    };
  }
  async createCommitJob(t, e, o = {}) {
    const n = await this.retrieveCommit(e);
    if ("v14" in n) {
      const i = JSON.parse(JSON.stringify(this.dataScienceDataRoom));
      ne(
        i,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (u) => {
          u.commits.push(n.v14);
        }
      );
      const a = eo(
        i
      ), r = t.reduce(
        (u, w) => {
          const g = a.get(w);
          if (!g)
            throw new Error(`Node ${w} not found`);
          return u[w] = ze(g), u;
        },
        {}
      ), c = await this.session.submitDevCompute(
        this.dataRoomId,
        e,
        Object.values(r),
        o
      );
      if (!c.jobId)
        throw new Error(`Job ID ${c.jobId} not found`);
      const m = X.util.binary.hex.encode(c.jobId);
      return {
        computeNodeIds: r,
        jobId: m
      };
    } else
      throw new Error("Unsupported commit version");
  }
  async retrieveJobStatus(t) {
    try {
      return (await this.session.getComputationStatus(
        t.jobId
      )).completeComputeNodeIds?.length === Object.keys(t.computeNodeIds).length ? {
        status: "completed"
      } : {
        status: "pending"
      };
    } catch (e) {
      const o = e instanceof Error ? e.message : String(e), n = o.match(/^(.+?): ([\s\S]*)/);
      if (n && n.length === 3) {
        const i = n[1], a = n[2], c = Object.keys(
          t.computeNodeIds
        ).reduce(
          (m, u) => (m[t.computeNodeIds[u]] = u, m),
          {}
        )[i];
        if (c)
          return {
            error: {
              extraInfo: {
                nodeId: c,
                originalMessage: o
              },
              message: a
            },
            status: "failed"
          };
      }
      return {
        error: { message: o },
        status: "failed"
      };
    }
  }
  async testAllComputations(t) {
    const e = [];
    this.configurationNodesCache.forEach((n) => {
      "computation" in n.kind && !("preview" in n.kind.computation.kind) && e.push(n.id);
    });
    const o = await this.createJob(e, {
      dryRun: { testDatasets: t }
    });
    return await this.waitForJobCompletion(o), o;
  }
  async waitForJobCompletion(t, e = 1e3, o) {
    let n = !1, i;
    o !== void 0 && (i = setTimeout(() => n = !0, o));
    try {
      for (; !n; ) {
        const a = await this.retrieveJobStatus(t);
        switch (a.status) {
          case "pending": {
            await new Promise(
              (r) => setTimeout(r, e)
            );
            continue;
          }
          case "failed":
            throw a.error;
          case "completed":
            return;
        }
      }
      throw new Error("Timeout reached");
    } finally {
      i !== void 0 && clearTimeout(i);
    }
  }
  async retrieveComputationFormat(t, e) {
    const o = await this.createJob([t], {
      dryRun: { testDatasets: e }
    });
    await this.waitForJobCompletion(o);
    const i = (await this.fetchJobResult(o)).get(t), a = gt.withSize(1e3);
    if (i)
      for await (const r of i)
        a.extend(r);
    return a.view();
  }
  async retrieveCurrentConfiguration() {
    return await this.session.retrieveCurrentDataRoomConfiguration(
      this.dataRoomId
    );
  }
  async fetchJobResult(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o], i = vt(
        this.session.streamJobResults(
          X.util.binary.hex.decode(t.jobId),
          n
        ),
        async (a) => {
          if (a.data === null || a.data === void 0)
            throw new Error("Invalid data chunk");
          return a.data;
        }
      );
      e.set(o, i);
    }
    return e;
  }
  async fetchJobResultSize(t) {
    const e = /* @__PURE__ */ new Map();
    for (const o in t.computeNodeIds) {
      const n = t.computeNodeIds[o];
      e.set(
        o,
        await this.session.getComputationResultSize({
          computeNodeId: n,
          jobId: t.jobId
        })
      );
    }
    return e;
  }
  async fetchAuditlog() {
    const t = await this.session.retrieveAuditLog(this.dataRoomId);
    if (!t.log)
      throw new Error("Audit log not found");
    return new TextDecoder().decode(t.log);
  }
  async stopDataroom() {
    await this.session.stopDataRoom(this.dataRoomId);
  }
  async createCommit(t) {
    return await this.session.publishDataScienceCommit(t, {
      v14: this.dataScienceDataRoom
    });
  }
  // Move to super
  async retrieveCommit(t) {
    return await this.session.retrieveDataScienceCommit(t, {
      v14: this.dataScienceDataRoom
    });
  }
  async retrieveCommitApprovers(t) {
    return await this.session.retrieveConfigurationCommitApprovers(t);
  }
  async generateMergeSignature(t) {
    return await this.session.generateMergeApprovalSignature(t);
  }
  async mergeCommit(t, e) {
    const o = await this.retrieveCommit(t);
    if ("v14" in o) {
      ne(
        this.dataScienceDataRoom,
        () => {
          throw new Error(
            "Cannot merge commit with static data science data room"
          );
        },
        (i) => {
          i.commits.push(o.v14);
        }
      );
      const n = this.session.compiler.compileDataScienceDataRoom({
        v14: this.dataScienceDataRoom
      });
      await this.session.mergeConfigurationCommit(t, e, {
        newHighLevelDcrRepresentation: n.highLevel
      });
    } else
      throw new Error("Unsupported version");
  }
  getEnclaveSpecifications() {
    return ne(
      this.dataScienceDataRoom,
      (t) => t.enclaveSpecifications,
      (t) => {
        const e = t.initialConfiguration.enclaveSpecifications;
        return t.commits.forEach((o) => {
          const n = o.kind;
          if ("addComputation" in n)
            e.push(
              ...n.addComputation.enclaveSpecifications
            );
          else
            throw new Error("Unknown commit kind");
        }), e;
      }
    );
  }
  getNodes() {
    return Array.from(this.configurationNodesCache.values());
  }
  async validateTableNode(t) {
    const e = await this.createJob([t]);
    await this.waitForJobCompletion(e);
    const o = await this.fetchJobResult(e), n = await this.getZipTextFile(
      o,
      t,
      "validation-report.json"
    );
    return JSON.parse(n);
  }
  async getZipTextFile(t, e, o) {
    return await bt(t, e, o);
  }
  getEnclaveDependencyNodeIdForNode(t) {
    const e = this.getNodes().find(
      (o) => o.id === t
    );
    if (!e)
      throw new Error(`No compute node found with id '${t}'`);
    return ze(e);
  }
}
function kn(s, t, e) {
  if ("v0" in t)
    return new sn(
      s,
      t.v0,
      e
    );
  if ("v1" in t)
    return new cn(
      s,
      t.v1,
      e
    );
  if ("v2" in t)
    return new dn(
      s,
      t.v2,
      e
    );
  if ("v3" in t)
    return new un(
      s,
      t.v3,
      e
    );
  if ("v4" in t)
    return new ln(
      s,
      t.v4,
      e
    );
  if ("v5" in t)
    return new hn(
      s,
      t.v5,
      e
    );
  if ("v6" in t)
    return new fn(
      s,
      t.v6,
      e
    );
  if ("v7" in t)
    return new mn(
      s,
      t.v7,
      e
    );
  if ("v8" in t)
    return new pn(
      s,
      t.v8,
      e
    );
  if ("v9" in t)
    return new wn(
      s,
      t.v9,
      e
    );
  if ("v10" in t)
    return new gn(
      s,
      t.v10,
      e
    );
  if ("v11" in t)
    return new bn(
      s,
      t.v11,
      e
    );
  if ("v12" in t)
    return new vn(
      s,
      t.v12,
      e
    );
  if ("v13" in t)
    return new yn(
      s,
      t.v13,
      e
    );
  if ("v14" in t)
    return new Cn(
      s,
      t.v14,
      e
    );
  throw new Error("No dcr wrapper for this version available");
}
const ri = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  concatenateChunks: lo,
  createDataScienceDataRoomWrapper: kn
}, Symbol.toStringTag, { value: "Module" }));
async function _n(s, t, e, {
  targetConfig: o,
  credentials: n,
  encryptionKey: i,
  manifestHash: a
}) {
  const r = await pt({
    config: o,
    graphqlClient: s.graphql,
    payload: {
      manifestHash: a,
      targetType: Nt.S3,
      type: lt.ExportDataset
    }
  }), c = new TextEncoder().encode(
    JSON.stringify({
      accessKey: n.accessKey,
      secretKey: n.secretKey
    })
  ), m = new yt("Dataset export S3", e);
  m.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  }), m.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  });
  const { bucket: u, region: w, key: g } = o, f = {
    dependency: "data",
    raw: {
      key: g
    }
  }, v = new At("sink", {
    credentialsDependency: "credentials",
    endpoint: `https://${u}.s3.${w}.amazonaws.com`,
    objects: [f],
    region: w,
    s3Provider: "AWS"
  });
  m.addComputeNode(v, { nodeId: "sink" }), m.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("credentials"),
      G.leafCrud("data"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const h = m.build(), b = await t.publishDataRoom(h, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  }), p = new Ct(), y = await s.uploadDataset(
    c,
    p,
    "AWS Credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    b,
    y,
    "credentials",
    p
  ), await t.publishDataset(b, a, "data", i);
  const _ = await t.runComputation(b, "sink"), S = e.get("decentriq.driver"), D = ft(S);
  return await mt(s.graphql, r, {
    computeJobId: _.jobId,
    computeJobNode: _.computeNodeId,
    dataRoomId: b,
    driverAttestationHash: D
  }), r;
}
async function In(s, t, e, {
  encryptionKey: o,
  manifestHash: n,
  aws: i,
  segmentOwners: a
}) {
  const r = await pt({
    config: {
      aws: i,
      segmentOwners: a
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: n,
      targetType: Nt.Adform,
      type: lt.ExportDataset
    }
  }), c = new yt(
    "Dataset export Adform DSP",
    e
  );
  c.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  });
  const m = bo.SinkInput.create({
    dependency: "data",
    name: "data",
    raw: {}
  }), u = new jo(
    "adform",
    {
      input: m,
      segmentOwners: a
    }
  );
  c.addComputeNode(u, { nodeId: "adform" }), c.addDataNode("s3Credentials", {
    isRequired: !0,
    nodeId: "s3Credentials"
  });
  const { bucket: w, region: g, key: f } = i?.targetConfig || {}, v = (/* @__PURE__ */ new Date()).toISOString().split("T")[0].replaceAll("-", ""), h = f.lastIndexOf("/");
  let b = "";
  if (h > 0) {
    const V = f.slice(0, h), I = f.slice(h + 1);
    b = `${V}/dt=${v}/${I}`;
  } else {
    const V = f.slice(h + 1);
    b = `dt=${v}/${V}`;
  }
  const p = {
    dependency: "adform",
    raw: {
      key: b
    }
  }, y = new At("s3Sink", {
    credentialsDependency: "s3Credentials",
    endpoint: `https://${w}.s3.${g}.amazonaws.com`,
    objects: [p],
    region: g,
    s3Provider: "AWS"
  });
  c.addComputeNode(y, { nodeId: "s3Sink" }), c.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("data"),
      G.leafCrud("s3Credentials"),
      G.executeCompute("s3Sink"),
      G.retrieveComputeResult("s3Sink")
    ]
  );
  const _ = c.build(), S = await t.publishDataRoom(_, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  });
  await t.publishDataset(S, n, "data", o);
  const D = new TextEncoder().encode(
    JSON.stringify(i.credentials)
  ), T = new Ct(), x = await s.uploadDataset(
    D,
    T,
    "s3Credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    S,
    x,
    "s3Credentials",
    T
  );
  const F = await t.runComputation(S, "s3Sink"), A = e.get("decentriq.driver"), M = ft(A);
  return await mt(s.graphql, r, {
    computeJobId: F.jobId,
    computeJobNode: F.computeNodeId,
    dataRoomId: S,
    driverAttestationHash: M
  }), r;
}
async function Dn(s, t, e, {
  credentials: o,
  encryptionKey: n,
  manifestHash: i
}) {
  const a = await pt({
    config: {
      blobName: o.blobName,
      sasToken: o.sasToken,
      storageAccount: o.storageAccount,
      storageContainer: o.storageContainer
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: i,
      targetType: Nt.Azure,
      type: lt.ExportDataset
    }
  }), r = new yt("Dataset export Azure", e);
  r.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  }), r.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const c = vo.SinkInput.create({
    dependency: "data",
    name: "data",
    raw: {}
  }), m = new Ao("sink", {
    credentialsDependency: "credentials",
    input: c
  });
  r.addComputeNode(m, { nodeId: "sink" }), r.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("data"),
      G.leafCrud("credentials"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const u = r.build(), w = await t.publishDataRoom(u, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  });
  await t.publishDataset(w, i, "data", n);
  const g = new Ct(), f = JSON.stringify(o), v = await s.uploadDataset(
    new TextEncoder().encode(f),
    g,
    "credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    w,
    v,
    "credentials",
    g
  );
  const h = await t.runComputation(w, "sink"), b = e.get("decentriq.driver"), p = ft(b);
  return await mt(s.graphql, a, {
    computeJobId: h.jobId,
    computeJobNode: h.computeNodeId,
    dataRoomId: w,
    driverAttestationHash: p
  }), a;
}
async function Sn(s, t, e, {
  advertiserId: o,
  displayName: n,
  description: i,
  membershipDurationDays: a,
  userConsentGiven: r,
  credentials: c,
  encryptionKey: m,
  manifestHash: u
}) {
  const w = await pt({
    config: {
      advertiserId: o,
      description: i,
      displayName: n,
      membershipDurationDays: a,
      userConsentGiven: r
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: u,
      targetType: Nt.GoogleDv_360,
      type: lt.ExportDataset
    }
  }), g = new yt("Dataset export DV360", e);
  g.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  }), g.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const f = yo.SinkInput.create({
    dependency: "data",
    name: "data",
    raw: {}
  }), v = new To("sink", {
    advertiserId: o,
    credentialsDependency: "credentials",
    description: i,
    displayName: n,
    input: f,
    membershipDurationDays: a,
    userConsentGiven: r
  });
  g.addComputeNode(v, { nodeId: "sink" }), g.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("data"),
      G.leafCrud("credentials"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const h = g.build(), b = await t.publishDataRoom(h, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  });
  await t.publishDataset(b, u, "data", m);
  const p = new Ct(), y = await s.uploadDataset(
    new TextEncoder().encode(c),
    p,
    "credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    b,
    y,
    "credentials",
    p
  );
  const _ = await t.runComputation(b, "sink"), S = e.get("decentriq.driver"), D = ft(S);
  return await mt(s.graphql, w, {
    computeJobId: _.jobId,
    computeJobNode: _.computeNodeId,
    dataRoomId: b,
    driverAttestationHash: D
  }), w;
}
async function Nn(s, t, e, {
  credentials: o,
  encryptionKey: n,
  manifestHash: i,
  identifierKind: a,
  listId: r,
  inputHasHeader: c,
  bucket: m,
  objectName: u
}) {
  const w = await pt({
    config: {
      bucket: m,
      identifierKind: a,
      inputHasHeader: c,
      listId: r,
      objectName: u
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: i,
      targetType: Nt.GoogleAdManager,
      type: lt.ExportDataset
    }
  }), g = new yt(
    "Dataset Export Google Ad Manager",
    e
  );
  g.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  }), g.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const f = Co.SinkInput.create({
    dependency: "data",
    name: "data",
    raw: {}
  }), v = new Jo(
    "sink",
    f,
    "credentials",
    a,
    r,
    c,
    m,
    u
  );
  g.addComputeNode(v, { nodeId: "sink" }), g.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("data"),
      G.leafCrud("credentials"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const h = g.build(), b = await t.publishDataRoom(h, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  });
  await t.publishDataset(b, i, "data", n);
  const p = new Ct(), y = await s.uploadDataset(
    new TextEncoder().encode(o),
    p,
    "credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    b,
    y,
    "credentials",
    p
  );
  const _ = await t.runComputation(b, "sink"), S = e.get("decentriq.driver"), D = ft(S);
  return await mt(s.graphql, w, {
    computeJobId: _.jobId,
    computeJobNode: _.computeNodeId,
    dataRoomId: b,
    driverAttestationHash: D
  }), w;
}
async function En(s, t, e, {
  bucketName: o,
  objectName: n,
  credentials: i,
  encryptionKey: a,
  manifestHash: r
}) {
  const c = await pt({
    config: {
      bucketName: o,
      objectName: n
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: r,
      targetType: Nt.GoogleCloudStorage,
      type: lt.ExportDataset
    }
  }), m = new yt("Dataset export GCS", e);
  m.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  }), m.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const u = new At("sink", {
    credentialsDependency: "credentials",
    endpoint: `https://${o}.storage.googleapis.com`,
    objects: [
      {
        dependency: "data",
        raw: {
          key: n
        }
      }
    ],
    s3Provider: "GCS"
  });
  m.addComputeNode(u, { nodeId: "sink" }), m.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("credentials"),
      G.leafCrud("data"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const w = m.build(), g = await t.publishDataRoom(w, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  }), f = new Ct(), v = await s.uploadDataset(
    new TextEncoder().encode(i),
    f,
    "credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    g,
    v,
    "credentials",
    f
  ), await t.publishDataset(g, r, "data", a);
  const h = await t.runComputation(g, "sink"), b = e.get("decentriq.driver"), p = ft(b);
  return await mt(s.graphql, c, {
    computeJobId: h.jobId,
    computeJobNode: h.computeNodeId,
    dataRoomId: g,
    driverAttestationHash: p
  }), c;
}
async function Rn(s, t, e, {
  manifestHash: o,
  accessToken: n,
  encryptionKey: i,
  adAccountId: a,
  audienceName: r
}) {
  if (!n)
    throw new Error("Access token is undefined or empty");
  const c = await pt({
    config: {
      adAccountId: a,
      audienceName: r
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: o,
      targetType: Nt.Meta,
      type: lt.ExportDataset
    }
  }), m = new yt("Dataset export Meta", e);
  m.addDataNode("access_token", {
    isRequired: !0,
    nodeId: "access_token"
  }), m.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  });
  const u = ko.SinkInput.create({
    dependency: "data",
    name: "users",
    raw: {}
  }), w = new Oo("sink", {
    accessTokenDependency: "access_token",
    adAccountId: a,
    audienceName: r,
    input: u
  });
  m.addComputeNode(w, { nodeId: "sink" }), m.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("access_token"),
      G.leafCrud("data"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const g = m.build(), f = await t.publishDataRoom(g, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  }), v = new Ct(), h = await s.uploadDataset(
    new TextEncoder().encode(n),
    v,
    "Meta access token",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    f,
    h,
    "access_token",
    v
  ), await t.publishDataset(f, o, "data", i);
  const b = await t.runComputation(f, "sink"), p = e.get("decentriq.driver"), y = ft(p);
  return await mt(s.graphql, c, {
    computeJobId: b.jobId,
    computeJobNode: b.computeNodeId,
    dataRoomId: f,
    driverAttestationHash: y
  }), c;
}
async function xn(s) {
  const t = Rt(`
    query MicrosoftDspMemberFromOrganisation {
      myself {
        organization {
          microsoftDspMember
        }
      }
    }
  `);
  return (await s.post({ query: t })).myself.organization?.microsoftDspMember;
}
async function jn(s, t, e, {
  memberId: o,
  segmentShortName: n,
  segmentCode: i,
  encryptionKey: a,
  manifestHash: r
}) {
  const c = await xn(
    s.graphql
  ), m = await pt({
    config: {
      targetConfig: {
        memberId: o,
        microsoftDspMember: c,
        segmentCode: i,
        segmentShortName: n
      }
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: r,
      targetType: Nt.MicrosoftDsp,
      type: lt.ExportDataset
    }
  });
  if (!c)
    throw new Error(
      "Microsoft DSP member is not defined for this organization"
    );
  const u = new yt(
    "Dataset export Microsoft DSP",
    e
  );
  u.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  });
  const w = _o.SinkInput.create({
    dependency: "data",
    name: "data",
    raw: {}
  }), g = new zo("sink", {
    input: w,
    memberId: o,
    memberName: c,
    segmentCode: i,
    segmentShortName: n
  });
  u.addComputeNode(g, { nodeId: "sink" }), u.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("data"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const f = u.build(), v = await t.publishDataRoom(f, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  });
  await t.publishDataset(v, r, "data", a);
  const h = await t.runComputation(v, "sink"), b = e.get("decentriq.driver"), p = ft(b);
  return await mt(s.graphql, m, {
    computeJobId: h.jobId,
    computeJobNode: h.computeNodeId,
    dataRoomId: v,
    driverAttestationHash: p
  }), m;
}
async function An(s, t, e, {
  credentials: o,
  encryptionKey: n,
  manifestHash: i,
  importId: a,
  segmentName: r,
  segmentCode: c,
  aws: m,
  gcs: u,
  inputHasHeader: w
}) {
  let g, f, v, h, b;
  if (m !== void 0) {
    const O = m;
    g = 1, h = O.targetConfig.bucket, b = O.targetConfig.key, f = new TextEncoder().encode(
      JSON.stringify(O.credentials)
    ), v = new At("s3Sink", {
      credentialsDependency: "s3Credentials",
      endpoint: `https://${O.targetConfig.bucket}.s3.${O.targetConfig.region}.amazonaws.com`,
      objects: [
        {
          dependency: "permutive",
          raw: {
            key: O.targetConfig.key
          }
        }
      ],
      region: O.targetConfig.region,
      s3Provider: "AWS"
    });
  } else if (u !== void 0) {
    const O = u;
    g = 0, h = O.bucketName, b = O.objectName, f = new TextEncoder().encode(O.credentials), v = new At("s3Sink", {
      contentType: "application/gzip",
      // This is required by GCS in order to correctly identify the file type.
      credentialsDependency: "s3Credentials",
      endpoint: `https://${O.bucketName}.storage.googleapis.com`,
      objects: [
        {
          dependency: "permutive",
          raw: {
            key: O.objectName
          }
        }
      ],
      s3Provider: "GCS"
    });
  } else
    throw new Error("Unknown S3 Provider");
  const p = await pt({
    config: {
      bucketName: h,
      importId: a,
      objectName: b,
      s3Provider: g,
      segmentCode: c,
      segmentName: r
    },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: i,
      targetType: Nt.Permutive,
      type: lt.ExportDataset
    }
  }), y = new yt("Dataset export Permutive", e);
  y.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  }), y.addDataNode("permutiveCredentials", {
    isRequired: !0,
    nodeId: "permutiveCredentials"
  }), y.addDataNode("s3Credentials", {
    isRequired: !0,
    nodeId: "s3Credentials"
  });
  const _ = Io.SinkInput.create({
    dependency: "data",
    name: "data",
    raw: {}
  }), S = new Po(
    "permutive",
    {
      credentialsDependency: "permutiveCredentials",
      importId: a,
      input: _,
      inputHasHeaders: w,
      segmentCode: c,
      segmentName: r
    }
  );
  y.addComputeNode(S, { nodeId: "permutive" }), y.addComputeNode(v, { nodeId: "s3Sink" }), y.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("data"),
      G.leafCrud("permutiveCredentials"),
      G.leafCrud("s3Credentials"),
      G.executeCompute("s3Sink"),
      G.retrieveComputeResult("s3Sink")
    ]
  );
  const D = y.build(), T = await t.publishDataRoom(D, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  });
  await t.publishDataset(T, i, "data", n);
  const x = new Ct(), F = JSON.stringify(o);
  let A = await s.uploadDataset(
    new TextEncoder().encode(F),
    x,
    "permutiveCredentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    T,
    A,
    "permutiveCredentials",
    x
  ), A = await s.uploadDataset(
    f,
    x,
    "s3Credentials",
    { isAccessory: !0 }
  ), await t.publishDataset(
    T,
    A,
    "s3Credentials",
    x
  );
  const M = await t.runComputation(T, "s3Sink"), V = e.get("decentriq.driver"), I = ft(V);
  return await mt(s.graphql, p, {
    computeJobId: M.jobId,
    computeJobNode: M.computeNodeId,
    dataRoomId: T,
    driverAttestationHash: I
  }), p;
}
async function Tn(s, t, e, {
  seatId: o,
  userDefinedAudienceName: n,
  encryptionKey: i,
  manifestHash: a
}) {
  const r = await pt({
    config: { seatId: o, userDefinedAudienceName: n },
    graphqlClient: s.graphql,
    payload: {
      manifestHash: a,
      targetType: Nt.Splicky,
      type: lt.ExportDataset
    }
  }), c = new yt("Dataset export Splicky", e);
  c.addDataNode("data", {
    isRequired: !0,
    nodeId: "data"
  });
  const m = "decentriq", u = "eu-central-1", g = {
    dependency: "data",
    raw: {
      key: await Jn(
        s,
        a,
        o,
        n
      )
    }
  }, f = new At("sink", {
    endpoint: `https://${m}.s3.${u}.amazonaws.com`,
    objects: [g],
    region: u,
    s3Provider: "AWS",
    useSplickyCredentials: !0
  });
  c.addComputeNode(f, { nodeId: "sink" }), c.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("data"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const v = c.build(), h = await t.publishDataRoom(v, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  });
  await t.publishDataset(h, a, "data", i);
  const b = await t.runComputation(h, "sink"), p = e.get("decentriq.driver"), y = ft(p);
  return await mt(s.graphql, r, {
    computeJobId: b.jobId,
    computeJobNode: b.computeNodeId,
    dataRoomId: h,
    driverAttestationHash: y
  }), r;
}
async function Jn(s, t, e, o) {
  const i = Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3), a = s.userEmail, r = a.indexOf("@"), c = a.slice(r + 1), m = await s.getDataset(t), u = m.name;
  if (!m.datasetImport)
    throw new Error(
      "Expected a datasetImport to be associated with the dataset"
    );
  const w = m.datasetImport?.dataRoomId;
  if (!new RegExp("^[a-zA-Z0-9_ -?%]*$").test(u))
    throw new Error("Dataset name did not match the expected format");
  const f = u.indexOf(" "), v = Pt(
    u.substring(0, f)
  ), h = u.substring(f + 1), b = h.indexOf("-");
  let p = "";
  if (b > 0) {
    const D = Pt(
      h.substring(0, b).trim()
    ), T = Pt(
      h.substring(b + 1).trim()
    );
    p = `${w}_${D}_${v}_${T}`;
  } else {
    const D = Pt(h.trim());
    p = `${w}_${D}_${v}`;
  }
  const y = Pt(
    o
  );
  return `decentriq-${i}-${e}-${c}-${y}-${p}-oneid.csv`;
}
function Pt(s) {
  return s.replace(/[&\\{}^%`[\]">~<#|]/g, "").replace(/[&_-]/g, " ");
}
const si = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exportDatasetAdformDsp: In,
  exportDatasetAzure: Dn,
  exportDatasetDv360: Sn,
  exportDatasetGCS: En,
  exportDatasetGoogleAdManager: Nn,
  exportDatasetMeta: Rn,
  exportDatasetMicrosoftDsp: jn,
  exportDatasetPermutive: An,
  exportDatasetS3: _n,
  exportDatasetSplicky: Tn
}, Symbol.toStringTag, { value: "Module" }));
async function On(s, t, e, {
  credentials: o,
  encryptionKey: n,
  name: i,
  datasetName: a
}) {
  const r = await pt({
    config: {
      blobName: o.blobName,
      sasToken: o.sasToken,
      storageAccount: o.storageAccount,
      storageContainer: o.storageContainer
    },
    graphqlClient: s.graphql,
    payload: {
      datasetName: a,
      name: i,
      sourceType: Tt.Azure,
      type: lt.ImportDataset
    }
  }), c = new yt("Dataset Import Azure", e);
  c.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const m = new $o(
    "source",
    {
      credentialsDependency: "credentials"
    }
  );
  c.addComputeNode(m, { nodeId: "source" }), c.addDataNode("key", {
    isRequired: !0,
    nodeId: "key"
  });
  const u = new $t("sink", {
    datasetImportId: r,
    encryptionKeyDependency: "key",
    inputs: [
      jt.SinkInput.create({
        dependency: "source",
        name: a,
        raw: {}
      })
    ]
  });
  c.addComputeNode(u, { nodeId: "sink" }), c.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("credentials"),
      G.leafCrud("key"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const w = c.build(), g = await t.publishDataRoom(w, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_IMPORT
  }), f = new Ct(), v = JSON.stringify(o), h = await s.uploadDataset(
    new TextEncoder().encode(v),
    f,
    "Azure Credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    g,
    h,
    "credentials",
    f
  );
  const b = await s.uploadDataset(
    n.material,
    f,
    "Encryption Key",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    g,
    b,
    "key",
    f
  );
  const p = await t.runComputation(g, "sink"), y = e.get("decentriq.driver"), _ = ft(y);
  return await mt(s.graphql, r, {
    computeJobId: p.jobId,
    computeJobNode: p.computeNodeId,
    dataRoomId: g,
    driverAttestationHash: _
  }), r;
}
async function zn(s, t, e, {
  name: o,
  encryptionKey: n,
  datasetName: i,
  dataRoomId: a,
  computeNodeId: r,
  shouldImportAsRaw: c = !1,
  shouldImportAllFiles: m = !1,
  importFileWithName: u,
  renameFileTo: w,
  parameters: g = {}
}) {
  if (!((c ? 1 : 0) ^ (m ? 1 : 0) ^ (u ? 1 : 0)))
    throw new Error("Invalid file selection");
  const f = t.metaData.driverAttestationSpecificationHash, v = await pt({
    config: {
      computeNodeId: r,
      dataRoomId: a,
      driverAttestationHash: f
    },
    graphqlClient: s.graphql,
    payload: {
      datasetName: i,
      name: o,
      sourceType: Tt.Compute,
      type: lt.ImportDataset
    }
  }), { dataRoomConfiguration: h, historyPin: b } = await t.retrieveCurrentDataRoomConfiguration(a), p = new qo(
    "dataset_sink_node",
    a,
    h,
    b,
    e
  ), y = `${r}_sink`, _ = `${y}_key`;
  let S;
  if (c)
    S = jt.SinkInput.create({
      dependency: r,
      raw: {}
    });
  else if (m)
    S = jt.SinkInput.create({
      dependency: r,
      name: i,
      zip: {
        all: {}
      }
    });
  else if (u)
    S = jt.SinkInput.create({
      dependency: r,
      name: i,
      zip: {
        files: {
          names: [
            {
              name: u,
              renameAs: w
            }
          ]
        }
      }
    });
  else
    throw new Error("Invalid file selection");
  let D;
  try {
    const T = new $t(y, {
      datasetImportId: v,
      encryptionKeyDependency: _,
      inputs: [S],
      isKeyHexEncoded: !0
    });
    p.addComputeNode(T, { nodeId: y }), p.addParameterNode(_, {
      isRequired: !0,
      nodeId: _
    }), p.addUserPermission(
      t.metaData.email,
      await t.client.decentriqPkiAuthentication(),
      [
        G.executeCompute(y),
        G.retrieveComputeResult(y)
      ]
    );
    const x = p.build(), F = await t.publishDataRoomConfigurationCommit(x);
    D = await t.runDevComputation(a, F, y, {
      parameters: {
        ...g,
        [_]: n.toHex()
      }
    });
  } catch (T) {
    throw await ro(s.graphql, v), T;
  }
  return await mt(s.graphql, v, {
    computeJobId: D.jobId,
    computeJobNode: D.computeNodeId,
    dataRoomId: a,
    driverAttestationHash: f
  }), v;
}
async function Pn(s, t, e, {
  name: o,
  credentials: n,
  encryptionKey: i,
  objectName: a,
  bucketName: r,
  datasetName: c
}) {
  const m = await pt({
    config: {
      bucketName: r,
      objectName: a
    },
    graphqlClient: s.graphql,
    payload: {
      datasetName: c,
      name: o,
      sourceType: Tt.GoogleCloudStorage,
      type: lt.ImportDataset
    }
  }), u = new yt("Dataset Import GCS", e);
  u.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const w = new no("source", {
    bucket: r,
    credentialsDependency: "credentials",
    objectKey: a,
    s3Provider: "GCS"
  });
  u.addComputeNode(w, { nodeId: "source" }), u.addDataNode("key", {
    isRequired: !0,
    nodeId: "key"
  });
  const g = new $t("sink", {
    datasetImportId: m,
    encryptionKeyDependency: "key",
    inputs: [
      jt.SinkInput.create({
        dependency: "source",
        name: c,
        raw: {}
      })
    ]
  });
  u.addComputeNode(g, { nodeId: "sink" }), u.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("credentials"),
      G.leafCrud("key"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const f = u.build(), v = await t.publishDataRoom(f, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_EXPORT
  }), h = new Ct(), b = await s.uploadDataset(
    new TextEncoder().encode(n),
    h,
    "credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    v,
    b,
    "credentials",
    h
  );
  const p = await s.uploadDataset(
    i.material,
    h,
    "Encryption Key",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    v,
    p,
    "key",
    h
  );
  const y = await t.runComputation(v, "sink"), _ = e.get("decentriq.driver"), S = ft(_);
  return await mt(s.graphql, m, {
    computeJobId: y.jobId,
    computeJobNode: y.computeNodeId,
    dataRoomId: v,
    driverAttestationHash: S
  }), m;
}
async function $n(s, t, e, {
  encryptionKey: o,
  sourceConfig: n,
  credentials: i,
  name: a,
  datasetName: r
}) {
  const c = await pt({
    config: n,
    graphqlClient: s.graphql,
    payload: {
      datasetName: r,
      name: a,
      sourceType: Tt.S3,
      type: lt.ImportDataset
    }
  }), m = JSON.stringify(i), u = new yt("Dataset Import S3", e);
  u.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const w = new no("source", {
    bucket: n.bucket,
    credentialsDependency: "credentials",
    objectKey: n.objectKey,
    region: n.region,
    s3Provider: "AWS"
  });
  u.addComputeNode(w, { nodeId: "source" }), u.addDataNode("key", {
    isRequired: !0,
    nodeId: "key"
  });
  const g = new $t("sink", {
    datasetImportId: c,
    encryptionKeyDependency: "key",
    inputs: [
      jt.SinkInput.create({
        dependency: "source",
        name: r,
        raw: {}
      })
    ]
  });
  u.addComputeNode(g, { nodeId: "sink" }), u.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("credentials"),
      G.leafCrud("key"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const f = u.build(), v = await t.publishDataRoom(f, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_IMPORT
  }), h = new Ct(), b = await s.uploadDataset(
    new TextEncoder().encode(m),
    h,
    "AWS Credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    v,
    b,
    "credentials",
    h
  );
  const p = await s.uploadDataset(
    o.material,
    h,
    "Encryption Key",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    v,
    p,
    "key",
    h
  );
  const y = await t.runComputation(v, "sink"), _ = e.get("decentriq.driver"), S = ft(_);
  return await mt(s.graphql, c, {
    computeJobId: y.jobId,
    computeJobNode: y.computeNodeId,
    dataRoomId: v,
    driverAttestationHash: S
  }), c;
}
async function Fn(s, t, e, {
  name: o,
  datasetName: n,
  encryptionKey: i,
  credentials: a,
  domainUrl: r,
  apiName: c,
  productType: m
}) {
  const u = await pt({
    config: {
      apiName: c,
      clientId: a.clientId,
      clientSecret: a.clientSecret,
      domainUrl: r,
      productType: m
    },
    graphqlClient: s.graphql,
    payload: {
      datasetName: n,
      name: o,
      sourceType: Tt.Salesforce,
      type: lt.ImportDataset
    }
  }), w = new yt(
    "Dataset Import Salesforce",
    e
  );
  w.addDataNode("credentials", {
    isRequired: !0,
    nodeId: "credentials"
  });
  const g = new Fo("source", {
    apiName: c,
    credentialsDependency: "credentials",
    domainUrl: r,
    productType: m
  });
  w.addComputeNode(g, { nodeId: "source" }), w.addDataNode("key", {
    isRequired: !0,
    nodeId: "key"
  });
  const f = new $t("sink", {
    datasetImportId: u,
    encryptionKeyDependency: "key",
    inputs: [
      jt.SinkInput.create({
        dependency: "source",
        name: n,
        raw: {}
      })
    ]
  });
  w.addComputeNode(f, { nodeId: "sink" }), w.addUserPermission(
    s.userEmail,
    await s.decentriqPkiAuthentication(),
    [
      G.leafCrud("credentials"),
      G.leafCrud("key"),
      G.executeCompute("sink"),
      G.retrieveComputeResult("sink")
    ]
  );
  const v = w.build(), h = await t.publishDataRoom(v, {
    dataRoomKind: at.CreateDcrKind.EXPERT,
    dataRoomPurpose: at.CreateDcrPurpose.DATA_IMPORT
  }), b = new Ct(), p = JSON.stringify(a), y = await s.uploadDataset(
    new TextEncoder().encode(p),
    b,
    "Salesforce Credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    h,
    y,
    "credentials",
    b
  );
  const _ = await s.uploadDataset(
    i.material,
    b,
    "Encryption Key",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    h,
    _,
    "key",
    b
  );
  const S = await t.runComputation(h, "sink"), D = e.get("decentriq.driver"), T = ft(D);
  return await mt(s.graphql, u, {
    computeJobId: S.jobId,
    computeJobNode: S.computeNodeId,
    dataRoomId: h,
    driverAttestationHash: T
  }), u;
}
async function Un(s, t, e, {
  sourceConfig: o,
  credentials: n,
  encryptionKey: i,
  name: a,
  datasetName: r
}) {
  const c = await pt({
    config: o,
    graphqlClient: s.graphql,
    payload: {
      datasetName: r,
      name: a,
      sourceType: Tt.Snowflake,
      type: lt.ImportDataset
    }
  }), m = {
    id: "snowflake-credentials",
    kind: {
      leaf: {
        isRequired: !0,
        kind: {
          raw: {}
        }
      }
    },
    name: "snowflake-credentials"
  }, u = {
    id: "encryption-key",
    kind: {
      leaf: {
        isRequired: !0,
        kind: {
          raw: {}
        }
      }
    },
    name: "encryption-key"
  }, w = {
    id: "snowflake-import",
    kind: {
      computation: {
        kind: {
          importConnector: {
            credentialsDependency: "snowflake-credentials",
            kind: {
              snowflake: {
                databaseName: o.databaseName,
                schemaName: o.schemaName,
                stageName: o.stageName,
                tableName: o.tableName,
                warehouseName: o.warehouseName
              }
            },
            specificationId: "decentriq.python-ml-worker-32-64"
          }
        }
      }
    },
    name: "snowflake-import"
  }, g = {
    id: "dataset-sink",
    kind: {
      computation: {
        kind: {
          datasetSink: {
            datasetImportId: c,
            encryptionKeyDependency: {
              dependency: "encryption-key",
              isKeyHexEncoded: !1
            },
            input: {
              datasetName: r,
              dependency: "snowflake-import",
              inputDataType: {
                zip: {
                  files: ["dataset.csv"]
                  // dataset.csv is the name of the file produced by the snowflake import worker
                }
              }
            },
            specificationId: "decentriq.dataset-sink-worker"
          }
        }
      }
    },
    name: "dataset-sink"
  }, f = await s.decentriqCaRootCertificate(), v = Array.from(e.keys()).map((A) => {
    const M = e.get(A);
    return {
      attestationProtoBase64: X.util.binary.base64.encode(
        $e.AttestationSpecification.encodeDelimited(
          M.proto
        ).finish()
      ),
      id: A,
      workerProtocol: M.workerProtocols[0]
    };
  }), h = [
    {
      permissions: [
        {
          dataOwner: { nodeId: "snowflake-credentials" }
        },
        {
          dataOwner: { nodeId: "encryption-key" }
        },
        {
          analyst: { nodeId: "snowflake-import" }
        },
        {
          analyst: { nodeId: "dataset-sink" }
        }
      ],
      user: s.userEmail
    }
  ], b = {
    v14: {
      static: {
        dcrSecretIdBase64: null,
        description: `Snowflake import for ${r}`,
        enableAirlock: !1,
        enableAllowEmptyFilesInValidation: !1,
        enableDevelopment: !1,
        enableForceSparkValidation: !1,
        enablePostWorker: !1,
        enableSafePythonWorkerStacktrace: !1,
        enableServersideWasmValidation: !1,
        enableSqliteWorker: !1,
        enableTestDatasets: !1,
        enclaveRootCertificatePem: new TextDecoder().decode(f),
        enclaveSpecifications: v,
        id: "snowflake-import",
        nodes: [
          m,
          u,
          w,
          g
        ],
        participants: h,
        title: `Snowflake import for ${r}`
      }
    }
  }, p = await t.publishDataScienceDataRoom(b, {
    dataRoomPurpose: at.CreateDcrPurpose.DATA_IMPORT
  }), y = new Ct(), _ = JSON.stringify(n), S = await s.uploadDataset(
    new TextEncoder().encode(_),
    y,
    "Snowflake Credentials",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    p,
    S,
    "snowflake-credentials",
    y
  );
  const D = await s.uploadDataset(
    i.material,
    y,
    "Encryption Key",
    { isAccessory: !0 }
  );
  await t.publishDataset(
    p,
    D,
    "encryption-key",
    y
  );
  const T = await t.runComputation(p, "dataset-sink"), x = e.get("decentriq.driver"), F = ft(x);
  return await mt(s.graphql, c, {
    computeJobId: T.jobId,
    computeJobNode: T.computeNodeId,
    dataRoomId: p,
    driverAttestationHash: F
  }), c;
}
const ci = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  importDatasetAzure: On,
  importDatasetCompute: zn,
  importDatasetGCS: Pn,
  importDatasetS3: $n,
  importDatasetSalesforce: Fn,
  importDatasetSnowflake: Un
}, Symbol.toStringTag, { value: "Module" })), di = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PostCompute: Uo,
  PostWorkerDecoder: Mo,
  proto: Do
}, Symbol.toStringTag, { value: "Module" }));
class ui {
  constructor(t, e) {
    this.client = t, this.driverDcapMrsignerAttestationSpecification = e, this.sessionsCache = /* @__PURE__ */ new Map(), this.sessionV2Cache = null;
  }
  sessionsCache;
  sessionV2Cache;
  reset() {
    this.sessionsCache.clear(), this.sessionV2Cache = null;
  }
  async getV2() {
    return this.sessionV2Cache ? await this.sessionV2Cache : await this.client.createSessionV2(
      this.driverDcapMrsignerAttestationSpecification
    );
  }
  async get(t) {
    if (t && "driverAttestationHash" in t && !t.driverAttestationHash)
      throw Error(
        "Session could not be established without an enclave driver attestation."
      );
    const e = t?.driverAttestationHash ? t.driverAttestationHash : "__DEFAULT__", o = this.sessionsCache.get(
      e
    );
    if (o)
      return await o;
    {
      const i = (async () => {
        const a = await this.client.getEnclaveSpecifications();
        function r(u) {
          const w = /* @__PURE__ */ new Map();
          for (const g of u)
            if (g.name === "decentriq.driver") {
              const f = oo.getAll().find((v) => v.name === g.name && v.version === g.version && ae(
                v.proto
              ) === ae(g.proto));
              if (f ? g.clientProtocols = f.clientProtocols : g.clientProtocols = [No], t?.driverAttestationHash)
                t?.driverAttestationHash === ae(g.proto) && w.set(g.name, g);
              else {
                const v = w.get(g.name);
                (!v || g.version === "mrsigner" || v.version !== "mrsigner" && g.version > v.version) && w.set(g.name, g);
              }
            }
          return w;
        }
        const c = r(a), m = await this.client.createAuthUsingDecentriqPki(c);
        return this.client.createSession(m, c);
      })();
      return this.sessionsCache.set(e, i), await i;
    }
  }
}
const li = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SqlCompute: Lo,
  SqlSchemaVerifier: Ko,
  SqlWorkerDecoder: Bo,
  proto: So
}, Symbol.toStringTag, { value: "Module" }));
export {
  Di as Api,
  Si as AppToken,
  Pi as Auth,
  Li as Client,
  Ni as ClientApiError,
  wi as Compiler,
  gi as DataLabDataset,
  yt as DataRoomBuilder,
  qo as DataRoomCommitBuilder,
  Wi as Endorser,
  Fi as GovernanceProtocol,
  No as LATEST_GCG_PROTOCOL_VERSION,
  qi as Noop,
  G as Permissions,
  At as S3SinkCompute,
  Ei as Secret,
  _i as Session,
  ui as SessionManager,
  Ri as SessionV2,
  Hi as StaticContent,
  xi as UserToken,
  ji as api,
  Ji as attestation,
  Ui as builder,
  Ki as client,
  ni as container,
  ii as data_connector_job,
  ai as data_lab,
  ri as data_science,
  bi as data_science_commit,
  vi as data_science_data_room,
  Oi as data_source_s3,
  oo as enclaveSpecifications,
  si as export_dataset,
  ci as import_dataset,
  yi as lookalike_media_request,
  Ci as media_insights_request,
  Gi as node,
  di as post,
  mi as proto,
  li as sql,
  Yi as types,
  Ai as utils
};
//# sourceMappingURL=index.js.map
